//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BAR_MANAGEMENT_BASE_URL = new InjectionToken<string>('API_BAR_MANAGEMENT_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class BarManagementService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BAR_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-bar-management";
    }

    /**
     * Gets the current checkIn for the current user
     * @param captureTime (optional) 
     * @return Success
     */
    getCheckInContext(openerId: string, captureTime?: Date | null | undefined): Observable<CheckInContextResponse> {
        let url_ = this.baseUrl + "/api/admin/check-in/{openerId}/check-in-context?";
        if (openerId === undefined || openerId === null)
            throw new Error("The parameter 'openerId' must be defined.");
        url_ = url_.replace("{openerId}", encodeURIComponent("" + openerId));
        if (captureTime !== undefined && captureTime !== null)
            url_ += "captureTime=" + encodeURIComponent(captureTime ? "" + captureTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckInContext(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckInContext(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckInContextResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckInContextResponse>;
        }));
    }

    protected processGetCheckInContext(response: HttpResponseBase): Observable<CheckInContextResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckInContextResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get active meeting
     * @param captureTime (optional) 
     * @return Success
     */
    getActiveMeetingByUserId(userId: string, captureTime?: Date | null | undefined): Observable<Meeting> {
        let url_ = this.baseUrl + "/api/admin/meeting/getActive/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (captureTime !== undefined && captureTime !== null)
            url_ += "captureTime=" + encodeURIComponent(captureTime ? "" + captureTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveMeetingByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveMeetingByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Meeting>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Meeting>;
        }));
    }

    protected processGetActiveMeetingByUserId(response: HttpResponseBase): Observable<Meeting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Meeting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create organization.
     * @param request (optional) 
     * @return Success
     */
    createOrganization(request?: CreateOrganizationRequest | null | undefined): Observable<Organization> {
        let url_ = this.baseUrl + "/api/AdminOrganization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Organization>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Organization>;
        }));
    }

    protected processCreateOrganization(response: HttpResponseBase): Observable<Organization> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Organization.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update organization.
     * @param request (optional) 
     * @return Success
     */
    updateAdminOrganization(request?: UpdateOrganizationRequest | null | undefined): Observable<Organization> {
        let url_ = this.baseUrl + "/api/AdminOrganization/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAdminOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAdminOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Organization>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Organization>;
        }));
    }

    protected processUpdateAdminOrganization(response: HttpResponseBase): Observable<Organization> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Organization.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get organization by id.
     * @return Success
     */
    getAdminOrganizationById(id: number): Observable<Organization> {
        let url_ = this.baseUrl + "/api/AdminOrganization/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminOrganizationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminOrganizationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Organization>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Organization>;
        }));
    }

    protected processGetAdminOrganizationById(response: HttpResponseBase): Observable<Organization> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Organization.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get organization by ids.
     * @param ids (optional) 
     * @return Success
     */
    getOrganizationsByIds(ids?: number[] | null | undefined): Observable<Organization[]> {
        let url_ = this.baseUrl + "/api/AdminOrganization/getOrganizationsByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationsByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationsByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Organization[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Organization[]>;
        }));
    }

    protected processGetOrganizationsByIds(response: HttpResponseBase): Observable<Organization[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Organization.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search organizations
     * @param query (optional) 
     * @return Success
     */
    queryOrganizations(query?: OrganizationQuery | null | undefined): Observable<OrganizationQueryResponse> {
        let url_ = this.baseUrl + "/api/AdminOrganization/queryOrganizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryOrganizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryOrganizations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationQueryResponse>;
        }));
    }

    protected processQueryOrganizations(response: HttpResponseBase): Observable<OrganizationQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search organizations
     * @return Success
     */
    getAllOrganizationsItem(): Observable<Item[]> {
        let url_ = this.baseUrl + "/api/AdminOrganization/getAllOrganizationsItem";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationsItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationsItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Item[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Item[]>;
        }));
    }

    protected processGetAllOrganizationsItem(response: HttpResponseBase): Observable<Item[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Item.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get organization upload URL
     * @return Success
     */
    getOrganizationUploadUrl(key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/AdminOrganization/getOrganizationUploadUrl/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetOrganizationUploadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update organization uploaded URLs
     * @return Success
     */
    updateOrganizationPhotos(key: string, organizationId: number): Observable<Organization> {
        let url_ = this.baseUrl + "/api/AdminOrganization/updateOrganizationPhotos/{organizationId}/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationPhotos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationPhotos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Organization>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Organization>;
        }));
    }

    protected processUpdateOrganizationPhotos(response: HttpResponseBase): Observable<Organization> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Organization.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get CSV for organization bulk import upload URL
     * @param key The key.
     * @param metadata (optional) The metadata.
     * @return Success
     */
    getCsvOrganizationBulkImportUploadUrl(key: string, metadata?: { [key: string]: string; } | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/AdminOrganization/getCsvOrganizationBulkImportUploadUrl/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metadata);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsvOrganizationBulkImportUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsvOrganizationBulkImportUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCsvOrganizationBulkImportUploadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the CSV bulk import result URL.
     * @return Success
     */
    getCsvOrganizationBulkImportLastResultUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/AdminOrganization/getCsvOrganizationBulkImportLastResultUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsvOrganizationBulkImportLastResultUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsvOrganizationBulkImportLastResultUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCsvOrganizationBulkImportLastResultUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the CSV organization bulk import result URL.
     * @param key The key.
     * @return Success
     */
    getCsvOrganizationBulkImportResultUrl(key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/AdminOrganization/getCsvOrganizationBulkImportResultUrl/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsvOrganizationBulkImportResultUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsvOrganizationBulkImportResultUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCsvOrganizationBulkImportResultUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get outlet vendors list by organization id
     * @return Success
     */
    getOutletVendorsByOrganizationId(organizationId: number): Observable<OutletVendor[]> {
        let url_ = this.baseUrl + "/api/AdminOrganization/getOutletVendorsByOrganizationIdd/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutletVendorsByOrganizationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletVendorsByOrganizationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutletVendor[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutletVendor[]>;
        }));
    }

    protected processGetOutletVendorsByOrganizationId(response: HttpResponseBase): Observable<OutletVendor[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutletVendor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get location from organization id
     * @param getByOrganizationIdPagedRequest (optional) 
     * @return Success
     */
    getPagedLocationsByAdminOrganizationId(getByOrganizationIdPagedRequest?: GetPagedLocationsByOrganizationIdRequest | null | undefined): Observable<Bar[]> {
        let url_ = this.baseUrl + "/api/AdminOrganization/getPagedLocationsByAdminOrganizationId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getByOrganizationIdPagedRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedLocationsByAdminOrganizationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedLocationsByAdminOrganizationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar[]>;
        }));
    }

    protected processGetPagedLocationsByAdminOrganizationId(response: HttpResponseBase): Observable<Bar[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Bar.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    createOrganizationAndOutlet(request?: CreateOrganizationAndOutletRequest | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/AdminOrganization/createOrganizationAndOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganizationAndOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationAndOutlet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrganizationAndOutlet(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getOrganizationTags(organizationId: number): Observable<OrganizationTag[]> {
        let url_ = this.baseUrl + "/api/AdminOrganizationTag/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationTag[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationTag[]>;
        }));
    }

    protected processGetOrganizationTags(response: HttpResponseBase): Observable<OrganizationTag[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    addOrganizationTag(organizationId: number, tag: string, value: string): Observable<OrganizationTag> {
        let url_ = this.baseUrl + "/api/AdminOrganizationTag/{organizationId}?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (tag === undefined || tag === null)
            throw new Error("The parameter 'tag' must be defined and cannot be null.");
        else
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined and cannot be null.");
        else
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrganizationTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrganizationTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationTag>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationTag>;
        }));
    }

    protected processAddOrganizationTag(response: HttpResponseBase): Observable<OrganizationTag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationTag.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    upsertOrganizationTag(organizationId: number, tag: string, value: string): Observable<OrganizationTag> {
        let url_ = this.baseUrl + "/api/AdminOrganizationTag/{organizationId}?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (tag === undefined || tag === null)
            throw new Error("The parameter 'tag' must be defined and cannot be null.");
        else
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined and cannot be null.");
        else
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertOrganizationTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertOrganizationTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationTag>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationTag>;
        }));
    }

    protected processUpsertOrganizationTag(response: HttpResponseBase): Observable<OrganizationTag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationTag.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateOrganizationTag(organizationId: number, tag: string, value: string): Observable<OrganizationTag> {
        let url_ = this.baseUrl + "/api/AdminOrganizationTag/{organizationId}/{tag}?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (tag === undefined || tag === null)
            throw new Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined and cannot be null.");
        else
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationTag>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationTag>;
        }));
    }

    protected processUpdateOrganizationTag(response: HttpResponseBase): Observable<OrganizationTag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationTag.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    removeOrganizationTag(tagId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/AdminOrganizationTag/{tagId}";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveOrganizationTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveOrganizationTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveOrganizationTag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tagSearch (optional) 
     * @return Success
     */
    getTagSuggestions(tagSearch?: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/AdminOrganizationTag/suggestTags?";
        if (tagSearch !== undefined && tagSearch !== null)
            url_ += "tagSearch=" + encodeURIComponent("" + tagSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTagSuggestions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tag (optional) 
     * @param valueSearch (optional) 
     * @return Success
     */
    getTagValuesSuggestions(tag?: string | null | undefined, valueSearch?: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/AdminOrganizationTag/suggestTagValues?";
        if (tag !== undefined && tag !== null)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        if (valueSearch !== undefined && valueSearch !== null)
            url_ += "valueSearch=" + encodeURIComponent("" + valueSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagValuesSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagValuesSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTagValuesSuggestions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get bar by id.
     * @return Success
     */
    getById(barId: number): Observable<Bar> {
        let url_ = this.baseUrl + "/api/Bar/getBarById/{barId}";
        if (barId === undefined || barId === null)
            throw new Error("The parameter 'barId' must be defined.");
        url_ = url_.replace("{barId}", encodeURIComponent("" + barId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<Bar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get bar by id.
     * @return Success
     */
    getDistributionBarById(barId: number): Observable<DistributionBar> {
        let url_ = this.baseUrl + "/api/Bar/distribution/getBarById/{barId}";
        if (barId === undefined || barId === null)
            throw new Error("The parameter 'barId' must be defined.");
        url_ = url_.replace("{barId}", encodeURIComponent("" + barId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistributionBarById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistributionBarById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DistributionBar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DistributionBar>;
        }));
    }

    protected processGetDistributionBarById(response: HttpResponseBase): Observable<DistributionBar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistributionBar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getByExternalId(externalId: string): Observable<Bar> {
        let url_ = this.baseUrl + "/api/Bar/getBarByExternalId/{externalId}";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar>;
        }));
    }

    protected processGetByExternalId(response: HttpResponseBase): Observable<Bar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param externalId (optional) 
     * @param campaignId (optional) 
     * @return Success
     */
    verifyBarAssociation(externalId?: string | null | undefined, campaignId?: string | null | undefined): Observable<Bar> {
        let url_ = this.baseUrl + "/api/Bar/verify-association?";
        if (externalId !== undefined && externalId !== null)
            url_ += "externalId=" + encodeURIComponent("" + externalId) + "&";
        if (campaignId !== undefined && campaignId !== null)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyBarAssociation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyBarAssociation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar>;
        }));
    }

    protected processVerifyBarAssociation(response: HttpResponseBase): Observable<Bar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add bar.
     * @param addBarRequest (optional) 
     * @return Success
     */
    addBar(addBarRequest?: AddBarRequest | null | undefined): Observable<Bar> {
        let url_ = this.baseUrl + "/api/Bar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addBarRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar>;
        }));
    }

    protected processAddBar(response: HttpResponseBase): Observable<Bar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a bar with address components from Google Maps JavaScript API.
     * @param addBarRequest (optional) 
     * @return Success
     */
    addBarWithAddressComponents(addBarRequest?: AddBarRequestWithAddressComponents | null | undefined): Observable<Bar> {
        let url_ = this.baseUrl + "/api/Bar/addBarWithAddressComponents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addBarRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBarWithAddressComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBarWithAddressComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar>;
        }));
    }

    protected processAddBarWithAddressComponents(response: HttpResponseBase): Observable<Bar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update bar.
     * @param request (optional) 
     * @return Success
     */
    update(request?: UpdateBarRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Bar/update-bar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete bar.
     * @param bar (optional) 
     * @return Success
     */
    delete(bar?: Bar | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Bar/delete-bar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bar);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search bars.
     * @param query (optional) 
     * @return Success
     */
    queryBars(query?: BarQuery | null | undefined): Observable<BarQueryResponse> {
        let url_ = this.baseUrl + "/api/Bar/queryBars";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryBars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryBars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarQueryResponse>;
        }));
    }

    protected processQueryBars(response: HttpResponseBase): Observable<BarQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search bars.
     * @param query (optional) 
     * @return Success
     */
    distributionQueryBars(query?: BarQuery | null | undefined): Observable<BarDistributionQueryResponse> {
        let url_ = this.baseUrl + "/api/Bar/distribution/queryBars";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDistributionQueryBars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDistributionQueryBars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarDistributionQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarDistributionQueryResponse>;
        }));
    }

    protected processDistributionQueryBars(response: HttpResponseBase): Observable<BarDistributionQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarDistributionQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Locations by OrganizationId
     * @return Success
     */
    getLocationsByOrganizationId(id: number): Observable<Bar[]> {
        let url_ = this.baseUrl + "/api/Bar/getLocationsByOrganizationId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationsByOrganizationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationsByOrganizationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar[]>;
        }));
    }

    protected processGetLocationsByOrganizationId(response: HttpResponseBase): Observable<Bar[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Bar.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get paged Locations by OrganizationId
     * @param getByOrganizationIdPagedRequest (optional) 
     * @return Success
     */
    getPagedLocationsByOrganizationId(getByOrganizationIdPagedRequest?: GetPagedLocationsByOrganizationIdRequest | null | undefined): Observable<Bar[]> {
        let url_ = this.baseUrl + "/api/Bar/getPagedLocationsByOrganizationId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getByOrganizationIdPagedRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedLocationsByOrganizationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedLocationsByOrganizationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar[]>;
        }));
    }

    protected processGetPagedLocationsByOrganizationId(response: HttpResponseBase): Observable<Bar[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Bar.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get CSV bulk import upload URL
     * @return Success
     */
    getCsvBulkImportUploadUrl(organizationId: number, key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/Bar/getCsvBulkImportUploadUrl/{organizationId}/{key}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsvBulkImportUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsvBulkImportUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCsvBulkImportUploadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCsvBulkImportResultUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/Bar/getCsvBulkImportResultUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsvBulkImportResultUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsvBulkImportResultUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCsvBulkImportResultUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get organization upload URL
     * @return Success
     */
    getBarUploadUrl(key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/Bar/getBarUploadUrl/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetBarUploadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get bar by id
     * @return Success
     */
    getBarById(id: number): Observable<Bar> {
        let url_ = this.baseUrl + "/api/BarApp/getBarById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar>;
        }));
    }

    protected processGetBarById(response: HttpResponseBase): Observable<Bar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get last bars that the user has checked-in.
     * @param limit (optional) 
     * @return Success
     */
    getLastCheckedInBars(limit?: number | null | undefined): Observable<Bar[]> {
        let url_ = this.baseUrl + "/api/BarApp/getLastCheckedInBars?";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastCheckedInBars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastCheckedInBars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar[]>;
        }));
    }

    protected processGetLastCheckedInBars(response: HttpResponseBase): Observable<Bar[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Bar.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get nearby bars.
     * @param lat (optional) 
     * @param lng (optional) 
     * @param distance (optional) Expressed in kilometers.
     * @param limit (optional) 
     * @return Success
     */
    getNearbyBars(lat?: number | null | undefined, lng?: number | null | undefined, distance?: number | null | undefined, limit?: number | null | undefined): Observable<Bar[]> {
        let url_ = this.baseUrl + "/api/BarApp/getNearbyBars?";
        if (lat !== undefined && lat !== null)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (lng !== undefined && lng !== null)
            url_ += "lng=" + encodeURIComponent("" + lng) + "&";
        if (distance !== undefined && distance !== null)
            url_ += "distance=" + encodeURIComponent("" + distance) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNearbyBars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNearbyBars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar[]>;
        }));
    }

    protected processGetNearbyBars(response: HttpResponseBase): Observable<Bar[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Bar.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search bars by name
     * @param search (optional) 
     * @param limit (optional) 
     * @return Success
     */
    searchBarByName(search?: string | null | undefined, limit?: number | null | undefined): Observable<Bar[]> {
        let url_ = this.baseUrl + "/api/BarApp/searchBarByName?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBarByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBarByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar[]>;
        }));
    }

    protected processSearchBarByName(response: HttpResponseBase): Observable<Bar[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Bar.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getBarsAsOwnerForCurrentOrganization(): Observable<Bar[]> {
        let url_ = this.baseUrl + "/api/BarApp/barsAsOwnerForCurrentOrganization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarsAsOwnerForCurrentOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarsAsOwnerForCurrentOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar[]>;
        }));
    }

    protected processGetBarsAsOwnerForCurrentOrganization(response: HttpResponseBase): Observable<Bar[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Bar.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get organization upload URL
     * @return Success
     */
    getOutletUploadUrl(key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/BarApp/getOutletUploadUrl/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutletUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetOutletUploadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update organization uploaded URLs
     * @return Success
     */
    updateOuteletPhotos(key: string, outletId: number): Observable<Bar> {
        let url_ = this.baseUrl + "/api/BarApp/updateOutletPhotos/{outletId}/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (outletId === undefined || outletId === null)
            throw new Error("The parameter 'outletId' must be defined.");
        url_ = url_.replace("{outletId}", encodeURIComponent("" + outletId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOuteletPhotos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOuteletPhotos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar>;
        }));
    }

    protected processUpdateOuteletPhotos(response: HttpResponseBase): Observable<Bar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    updateOutletAsOwner(outletId: number, name?: string | null | undefined): Observable<Bar> {
        let url_ = this.baseUrl + "/api/BarApp/updateOutletAsOwner/{outletId}?";
        if (outletId === undefined || outletId === null)
            throw new Error("The parameter 'outletId' must be defined.");
        url_ = url_.replace("{outletId}", encodeURIComponent("" + outletId));
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOutletAsOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOutletAsOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar>;
        }));
    }

    protected processUpdateOutletAsOwner(response: HttpResponseBase): Observable<Bar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current checkIn for the current user
     * @return Success
     */
    getCurrentCheckIn(): Observable<CheckIn> {
        let url_ = this.baseUrl + "/api/check-in";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentCheckIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentCheckIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckIn>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckIn>;
        }));
    }

    protected processGetCurrentCheckIn(response: HttpResponseBase): Observable<CheckIn> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckIn.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Request a check-in for the given barId and the openerId
     * @param parameters (optional) Request parameters
     * @return Success
     */
    requestCheckIn(parameters?: RequestCheckInParameters | null | undefined): Observable<CheckInRequest> {
        let url_ = this.baseUrl + "/api/check-in/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestCheckIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestCheckIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckInRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckInRequest>;
        }));
    }

    protected processRequestCheckIn(response: HttpResponseBase): Observable<CheckInRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckInRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a check-in request. Use to verify the status of a check-in
     * @param checkInRequestId (optional) 
     * @return Success
     */
    getCheckInRequest(checkInRequestId?: string | null | undefined): Observable<CheckInRequest> {
        let url_ = this.baseUrl + "/api/check-in/request?";
        if (checkInRequestId !== undefined && checkInRequestId !== null)
            url_ += "checkInRequestId=" + encodeURIComponent("" + checkInRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckInRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckInRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckInRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckInRequest>;
        }));
    }

    protected processGetCheckInRequest(response: HttpResponseBase): Observable<CheckInRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckInRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks-out the user
     * @return Success
     */
    checkout(): Observable<void> {
        let url_ = this.baseUrl + "/api/check-in/check-out";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks-out the user
     * @param outletId (optional) 
     * @return Success
     */
    getListOpenersByBar(outletId?: number | null | undefined): Observable<CheckIn[]> {
        let url_ = this.baseUrl + "/api/check-in/openers-last-login?";
        if (outletId !== undefined && outletId !== null)
            url_ += "outletId=" + encodeURIComponent("" + outletId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListOpenersByBar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListOpenersByBar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckIn[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckIn[]>;
        }));
    }

    protected processGetListOpenersByBar(response: HttpResponseBase): Observable<CheckIn[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckIn.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search for devices in IoT Fleet indexing.
     * @param filters (optional) If there is any value in the SeriaNumber array it will first retrieve those devices and then apply the filter in memory.
    You can specify a maximum of 100 serial numbers.
    Because IoT Fleet indexing suports only five search criterias and we use one to filter the environment you can specify a maximum of four search criterias (excluding serial numbers).
     * @return Success
     */
    searchDevices(filters?: DeviceFilters | null | undefined): Observable<FleetIndexResponse> {
        let url_ = this.baseUrl + "/api/admin/Device/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FleetIndexResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FleetIndexResponse>;
        }));
    }

    protected processSearchDevices(response: HttpResponseBase): Observable<FleetIndexResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FleetIndexResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result410: any = null;
            let resultData410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result410 = ClientErrorMessageResponse.fromJS(resultData410);
            return throwException("Client Error", status, _responseText, _headers, result410);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search for devices in IoT Fleet indexing.
     * @param filters (optional) If there is any value in the SeriaNumber array it will first retrieve those devices and then apply the filter in memory.
    You can specify a maximum of 100 serial numbers.
    Because IoT Fleet indexing suports only five search criterias and we use one to filter the environment you can specify a maximum of four search criterias (excluding serial numbers).
     * @return Success
     */
    countDevices(filters?: DeviceFilters | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/admin/Device/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCountDevices(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add outlet attribute for a specific device
     * @param device (optional) 
     * @return Success
     */
    setDeviceOutletAttribute(device?: Device | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/Device/setDeviceOutletAttribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDeviceOutletAttribute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDeviceOutletAttribute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDeviceOutletAttribute(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search address.
     * @param address (optional) 
     * @return Success
     */
    searchAddress(address?: string | null | undefined): Observable<Address[]> {
        let url_ = this.baseUrl + "/api/GoogleMaps/searchAddress?";
        if (address !== undefined && address !== null)
            url_ += "address=" + encodeURIComponent("" + address) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Address[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Address[]>;
        }));
    }

    protected processSearchAddress(response: HttpResponseBase): Observable<Address[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Address.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search by geo code
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @return Success
     */
    geocode(latitude?: number | null | undefined, longitude?: number | null | undefined): Observable<Result[]> {
        let url_ = this.baseUrl + "/api/GoogleMaps/geocode?";
        if (latitude !== undefined && latitude !== null)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude !== undefined && longitude !== null)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeocode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeocode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result[]>;
        }));
    }

    protected processGeocode(response: HttpResponseBase): Observable<Result[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Result.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a meeting
     * @param createMeetingRequest (optional) 
     * @return Success
     */
    createMeeting(createMeetingRequest?: CreateMeetingRequest | null | undefined): Observable<Meeting> {
        let url_ = this.baseUrl + "/api/Meeting/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createMeetingRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Meeting>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Meeting>;
        }));
    }

    protected processCreateMeeting(response: HttpResponseBase): Observable<Meeting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Meeting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add participant
     * @param addParticipantRequest (optional) 
     * @return Success
     */
    addParticipant(addParticipantRequest?: AddParticipantRequest | null | undefined): Observable<Meeting> {
        let url_ = this.baseUrl + "/api/Meeting/addParticipant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addParticipantRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Meeting>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Meeting>;
        }));
    }

    protected processAddParticipant(response: HttpResponseBase): Observable<Meeting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Meeting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Join meeting
     * @param joinMeetingRequest (optional) 
     * @return Success
     */
    joinMeeting(joinMeetingRequest?: JoinMeetingRequest | null | undefined): Observable<Meeting> {
        let url_ = this.baseUrl + "/api/Meeting/join";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(joinMeetingRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJoinMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJoinMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Meeting>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Meeting>;
        }));
    }

    protected processJoinMeeting(response: HttpResponseBase): Observable<Meeting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Meeting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get active meeting
     * @return Success
     */
    getActiveMeeting(): Observable<Meeting> {
        let url_ = this.baseUrl + "/api/Meeting/getActive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Meeting>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Meeting>;
        }));
    }

    protected processGetActiveMeeting(response: HttpResponseBase): Observable<Meeting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Meeting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update organization.
     * @param request (optional) 
     * @return Success
     */
    updateOrganization(request?: UpdateOrganizationRequest | null | undefined): Observable<Organization> {
        let url_ = this.baseUrl + "/api/OrganizationApp/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Organization>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Organization>;
        }));
    }

    protected processUpdateOrganization(response: HttpResponseBase): Observable<Organization> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Organization.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get organization by id.
     * @return Success
     */
    getOrganizationById(id: number): Observable<Organization> {
        let url_ = this.baseUrl + "/api/OrganizationApp/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Organization>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Organization>;
        }));
    }

    protected processGetOrganizationById(response: HttpResponseBase): Observable<Organization> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Organization.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query vendors list.
     * @param query (optional) 
     * @return Success
     */
    queryOutletVendors(query?: OutletVendorQuery | null | undefined): Observable<OutletVendorQueryResponse> {
        let url_ = this.baseUrl + "/api/OutletVendor/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryOutletVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryOutletVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutletVendorQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutletVendorQueryResponse>;
        }));
    }

    protected processQueryOutletVendors(response: HttpResponseBase): Observable<OutletVendorQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutletVendorQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete outlet vendor.
     * @return Success
     */
    deleteOutletVendor(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OutletVendor/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOutletVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOutletVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOutletVendor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllMatchAlgorithms(): Observable<TextValueModel[]> {
        let url_ = this.baseUrl + "/api/OutletVendor/match-algorithms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMatchAlgorithms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMatchAlgorithms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TextValueModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TextValueModel[]>;
        }));
    }

    protected processGetAllMatchAlgorithms(response: HttpResponseBase): Observable<TextValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TextValueModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assign location
     * @param request (optional) 
     * @return Success
     */
    assignLocation(request?: AssignLocationRequest | null | undefined): Observable<Staff> {
        let url_ = this.baseUrl + "/api/StaffApp/assignLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Staff>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Staff>;
        }));
    }

    protected processAssignLocation(response: HttpResponseBase): Observable<Staff> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Staff.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query staff.
     * @param query (optional) 
     * @return Success
     */
    queryStaff(query?: StaffQuery | null | undefined): Observable<StaffQueryResponse> {
        let url_ = this.baseUrl + "/api/StaffApp/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffQueryResponse>;
        }));
    }

    protected processQueryStaff(response: HttpResponseBase): Observable<StaffQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create staff invitation.
     * @param request (optional) 
     * @return Success
     */
    createStaffInvitation(request?: CreateStaffInvitationRequest | null | undefined): Observable<StaffInvitation> {
        let url_ = this.baseUrl + "/api/StaffInvitationApp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStaffInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStaffInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffInvitation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffInvitation>;
        }));
    }

    protected processCreateStaffInvitation(response: HttpResponseBase): Observable<StaffInvitation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffInvitation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Accept staff invitation.
     * @return Staff invite accepted successfully
     */
    acceptStaffInvitation(code: string): Observable<StaffInvitation> {
        let url_ = this.baseUrl + "/api/StaffInvitationApp/accept/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptStaffInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptStaffInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StaffInvitation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StaffInvitation>;
        }));
    }

    protected processAcceptStaffInvitation(response: HttpResponseBase): Observable<StaffInvitation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffInvitation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Staff invite code is already used or expired", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid code. Staff invite not found.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("You are allready part of another organization with other roles. Cannot join multiple organizations.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearTestUserData(organizationId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/postman/TestHelper/clearOrganizationTestData/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearTestUserData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearTestUserData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearTestUserData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the API version of the device management sub-domain..
     * @return Success
     */
    getVersionInfo(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetVersionInfo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Helper method used to test exception handling.
     * @return Success
     */
    testException(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version/exception";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestException(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTestException(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Test Insights authorization
     * @return Success
     */
    testInsightsAuthorization(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version/testInsightsAuthorization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestInsightsAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestInsightsAuthorization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTestInsightsAuthorization(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AddBarRequest implements IAddBarRequest {
    name!: string;
    description?: string | null;
    lat!: number;
    lng!: number;
    officialAddress?: string | null;
    organizationId?: number | null;
    advertiserId?: string | null;

    constructor(data?: IAddBarRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : <any>null;
            this.officialAddress = _data["officialAddress"] !== undefined ? _data["officialAddress"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.advertiserId = _data["advertiserId"] !== undefined ? _data["advertiserId"] : <any>null;
        }
    }

    static fromJS(data: any): AddBarRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddBarRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lng"] = this.lng !== undefined ? this.lng : <any>null;
        data["officialAddress"] = this.officialAddress !== undefined ? this.officialAddress : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["advertiserId"] = this.advertiserId !== undefined ? this.advertiserId : <any>null;
        return data;
    }
}

export interface IAddBarRequest {
    name: string;
    description?: string | null;
    lat: number;
    lng: number;
    officialAddress?: string | null;
    organizationId?: number | null;
    advertiserId?: string | null;
}

export class AddBarRequestWithAddressComponents implements IAddBarRequestWithAddressComponents {
    name!: string;
    description?: string | null;
    lat!: number;
    lng!: number;
    officialAddress?: string | null;
    organizationId?: number | null;
    addressComponents?: MapAddressComponent[] | null;
    formattedAddress?: string | null;
    placeId?: string | null;
    uploadKey?: string | null;
    vendorName?: string | null;
    externalId?: string | null;
    hasDefaultWifiConfig?: boolean | null;

    constructor(data?: IAddBarRequestWithAddressComponents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : <any>null;
            this.officialAddress = _data["officialAddress"] !== undefined ? _data["officialAddress"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            if (Array.isArray(_data["addressComponents"])) {
                this.addressComponents = [] as any;
                for (let item of _data["addressComponents"])
                    this.addressComponents!.push(MapAddressComponent.fromJS(item));
            }
            else {
                this.addressComponents = <any>null;
            }
            this.formattedAddress = _data["formattedAddress"] !== undefined ? _data["formattedAddress"] : <any>null;
            this.placeId = _data["placeId"] !== undefined ? _data["placeId"] : <any>null;
            this.uploadKey = _data["uploadKey"] !== undefined ? _data["uploadKey"] : <any>null;
            this.vendorName = _data["vendorName"] !== undefined ? _data["vendorName"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.hasDefaultWifiConfig = _data["hasDefaultWifiConfig"] !== undefined ? _data["hasDefaultWifiConfig"] : <any>null;
        }
    }

    static fromJS(data: any): AddBarRequestWithAddressComponents {
        data = typeof data === 'object' ? data : {};
        let result = new AddBarRequestWithAddressComponents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lng"] = this.lng !== undefined ? this.lng : <any>null;
        data["officialAddress"] = this.officialAddress !== undefined ? this.officialAddress : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        if (Array.isArray(this.addressComponents)) {
            data["addressComponents"] = [];
            for (let item of this.addressComponents)
                data["addressComponents"].push(item.toJSON());
        }
        data["formattedAddress"] = this.formattedAddress !== undefined ? this.formattedAddress : <any>null;
        data["placeId"] = this.placeId !== undefined ? this.placeId : <any>null;
        data["uploadKey"] = this.uploadKey !== undefined ? this.uploadKey : <any>null;
        data["vendorName"] = this.vendorName !== undefined ? this.vendorName : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["hasDefaultWifiConfig"] = this.hasDefaultWifiConfig !== undefined ? this.hasDefaultWifiConfig : <any>null;
        return data;
    }
}

export interface IAddBarRequestWithAddressComponents {
    name: string;
    description?: string | null;
    lat: number;
    lng: number;
    officialAddress?: string | null;
    organizationId?: number | null;
    addressComponents?: MapAddressComponent[] | null;
    formattedAddress?: string | null;
    placeId?: string | null;
    uploadKey?: string | null;
    vendorName?: string | null;
    externalId?: string | null;
    hasDefaultWifiConfig?: boolean | null;
}

/** Add participant request */
export class AddParticipantRequest implements IAddParticipantRequest {
    /** Meeting id. Can be null, but MeetingCode must be supplied in this case. */
    meetingId?: number | null;
    /** Meeting code */
    meetingCode?: string | null;
    /** Participant user id */
    participantId?: string | null;
    /** Participant phone number */
    participantPhoneNo?: string | null;

    constructor(data?: IAddParticipantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingId = _data["meetingId"] !== undefined ? _data["meetingId"] : <any>null;
            this.meetingCode = _data["meetingCode"] !== undefined ? _data["meetingCode"] : <any>null;
            this.participantId = _data["participantId"] !== undefined ? _data["participantId"] : <any>null;
            this.participantPhoneNo = _data["participantPhoneNo"] !== undefined ? _data["participantPhoneNo"] : <any>null;
        }
    }

    static fromJS(data: any): AddParticipantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddParticipantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingId"] = this.meetingId !== undefined ? this.meetingId : <any>null;
        data["meetingCode"] = this.meetingCode !== undefined ? this.meetingCode : <any>null;
        data["participantId"] = this.participantId !== undefined ? this.participantId : <any>null;
        data["participantPhoneNo"] = this.participantPhoneNo !== undefined ? this.participantPhoneNo : <any>null;
        return data;
    }
}

/** Add participant request */
export interface IAddParticipantRequest {
    /** Meeting id. Can be null, but MeetingCode must be supplied in this case. */
    meetingId?: number | null;
    /** Meeting code */
    meetingCode?: string | null;
    /** Participant user id */
    participantId?: string | null;
    /** Participant phone number */
    participantPhoneNo?: string | null;
}

export class Address implements IAddress {
    description?: string | null;
    place_id?: string | null;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.place_id = _data["place_id"] !== undefined ? _data["place_id"] : <any>null;
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["place_id"] = this.place_id !== undefined ? this.place_id : <any>null;
        return data;
    }
}

export interface IAddress {
    description?: string | null;
    place_id?: string | null;
}

export class AddressComponent implements IAddressComponent {
    short_name?: string | null;
    long_name?: string | null;
    types?: AddressComponentType[] | null;

    constructor(data?: IAddressComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.short_name = _data["short_name"] !== undefined ? _data["short_name"] : <any>null;
            this.long_name = _data["long_name"] !== undefined ? _data["long_name"] : <any>null;
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            else {
                this.types = <any>null;
            }
        }
    }

    static fromJS(data: any): AddressComponent {
        data = typeof data === 'object' ? data : {};
        let result = new AddressComponent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["short_name"] = this.short_name !== undefined ? this.short_name : <any>null;
        data["long_name"] = this.long_name !== undefined ? this.long_name : <any>null;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }
}

export interface IAddressComponent {
    short_name?: string | null;
    long_name?: string | null;
    types?: AddressComponentType[] | null;
}

export enum AddressComponentType {
    Unknown = "unknown",
    Street_address = "street_address",
    Route = "route",
    Intersection = "intersection",
    Political = "political",
    Country = "country",
    Administrative_area_level_1 = "administrative_area_level_1",
    Administrative_area_level_2 = "administrative_area_level_2",
    Administrative_area_level_3 = "administrative_area_level_3",
    Administrative_area_level_4 = "administrative_area_level_4",
    Administrative_area_level_5 = "administrative_area_level_5",
    Colloquial_area = "colloquial_area",
    Locality = "locality",
    Ward = "ward",
    Sublocality = "sublocality",
    Sublocality_level_1 = "sublocality_level_1",
    Sublocality_level_2 = "sublocality_level_2",
    Sublocality_level_3 = "sublocality_level_3",
    Sublocality_level_4 = "sublocality_level_4",
    Sublocality_level_5 = "sublocality_level_5",
    Neighborhood = "neighborhood",
    Premise = "premise",
    Subpremise = "subpremise",
    Postal_code = "postal_code",
    Natural_feature = "natural_feature",
    Airport = "airport",
    Park = "park",
    Floor = "floor",
    Establishment = "establishment",
    Point_of_interest = "point_of_interest",
    Parking = "parking",
    Post_box = "post_box",
    Postal_town = "postal_town",
    Room = "room",
    Street_number = "street_number",
    Bus_station = "bus_station",
    Train_station = "train_station",
    Transit_station = "transit_station",
    Geocode = "geocode",
    Postal_code_prefix = "postal_code_prefix",
    Postal_code_suffix = "postal_code_suffix",
    Plus_code = "plus_code",
}

export class AssignLocationRequest implements IAssignLocationRequest {
    staffId?: number | null;
    barId?: number | null;

    constructor(data?: IAssignLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staffId = _data["staffId"] !== undefined ? _data["staffId"] : <any>null;
            this.barId = _data["barId"] !== undefined ? _data["barId"] : <any>null;
        }
    }

    static fromJS(data: any): AssignLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffId"] = this.staffId !== undefined ? this.staffId : <any>null;
        data["barId"] = this.barId !== undefined ? this.barId : <any>null;
        return data;
    }
}

export interface IAssignLocationRequest {
    staffId?: number | null;
    barId?: number | null;
}

export class Bar implements IBar {
    id?: number | null;
    advertiserId?: string | null;
    name?: string | null;
    description?: string | null;
    organizationId?: number | null;
    lat?: number | null;
    lng?: number | null;
    officialAddress?: string | null;
    formattedAddress?: string | null;
    country?: string | null;
    countryCode?: string | null;
    streetAddress?: string | null;
    route?: string | null;
    streetNumber?: string | null;
    administrativeAreaL1?: string | null;
    administrativeAreaL1ShortName?: string | null;
    administrativeAreaL2?: string | null;
    administrativeAreaL2ShortName?: string | null;
    administrativeAreaL3?: string | null;
    administrativeAreaL3ShortName?: string | null;
    administrativeAreaL4?: string | null;
    administrativeAreaL4ShortName?: string | null;
    administrativeAreaL5?: string | null;
    administrativeAreaL5ShortName?: string | null;
    locality?: string | null;
    sublocality?: string | null;
    postalCode?: string | null;
    neighborhood?: string | null;
    placeId?: string | null;
    plusCodeGlobal?: string | null;
    plusCodeLocal?: string | null;
    timeZoneId?: string | null;
    timeZoneName?: string | null;
    state?: BarState | null;
    insightsId?: string | null;
    slug?: string | null;
    createdByInsightsUserId?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    source?: string | null;
    timestamp?: string | null;
    photoFull?: string | null;
    photoThumb?: string | null;
    externalId?: string | null;
    vendorName?: string | null;
    contactPerson?: string | null;
    email?: string | null;
    phone?: string | null;
    dataValidationNote?: string | null;
    lastValidationDate?: Date | null;
    hasDefaultWifiConfig?: boolean | null;

    constructor(data?: IBar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.advertiserId = _data["advertiserId"] !== undefined ? _data["advertiserId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : <any>null;
            this.officialAddress = _data["officialAddress"] !== undefined ? _data["officialAddress"] : <any>null;
            this.formattedAddress = _data["formattedAddress"] !== undefined ? _data["formattedAddress"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.streetAddress = _data["streetAddress"] !== undefined ? _data["streetAddress"] : <any>null;
            this.route = _data["route"] !== undefined ? _data["route"] : <any>null;
            this.streetNumber = _data["streetNumber"] !== undefined ? _data["streetNumber"] : <any>null;
            this.administrativeAreaL1 = _data["administrativeAreaL1"] !== undefined ? _data["administrativeAreaL1"] : <any>null;
            this.administrativeAreaL1ShortName = _data["administrativeAreaL1ShortName"] !== undefined ? _data["administrativeAreaL1ShortName"] : <any>null;
            this.administrativeAreaL2 = _data["administrativeAreaL2"] !== undefined ? _data["administrativeAreaL2"] : <any>null;
            this.administrativeAreaL2ShortName = _data["administrativeAreaL2ShortName"] !== undefined ? _data["administrativeAreaL2ShortName"] : <any>null;
            this.administrativeAreaL3 = _data["administrativeAreaL3"] !== undefined ? _data["administrativeAreaL3"] : <any>null;
            this.administrativeAreaL3ShortName = _data["administrativeAreaL3ShortName"] !== undefined ? _data["administrativeAreaL3ShortName"] : <any>null;
            this.administrativeAreaL4 = _data["administrativeAreaL4"] !== undefined ? _data["administrativeAreaL4"] : <any>null;
            this.administrativeAreaL4ShortName = _data["administrativeAreaL4ShortName"] !== undefined ? _data["administrativeAreaL4ShortName"] : <any>null;
            this.administrativeAreaL5 = _data["administrativeAreaL5"] !== undefined ? _data["administrativeAreaL5"] : <any>null;
            this.administrativeAreaL5ShortName = _data["administrativeAreaL5ShortName"] !== undefined ? _data["administrativeAreaL5ShortName"] : <any>null;
            this.locality = _data["locality"] !== undefined ? _data["locality"] : <any>null;
            this.sublocality = _data["sublocality"] !== undefined ? _data["sublocality"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
            this.neighborhood = _data["neighborhood"] !== undefined ? _data["neighborhood"] : <any>null;
            this.placeId = _data["placeId"] !== undefined ? _data["placeId"] : <any>null;
            this.plusCodeGlobal = _data["plusCodeGlobal"] !== undefined ? _data["plusCodeGlobal"] : <any>null;
            this.plusCodeLocal = _data["plusCodeLocal"] !== undefined ? _data["plusCodeLocal"] : <any>null;
            this.timeZoneId = _data["timeZoneId"] !== undefined ? _data["timeZoneId"] : <any>null;
            this.timeZoneName = _data["timeZoneName"] !== undefined ? _data["timeZoneName"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.insightsId = _data["insightsId"] !== undefined ? _data["insightsId"] : <any>null;
            this.slug = _data["slug"] !== undefined ? _data["slug"] : <any>null;
            this.createdByInsightsUserId = _data["createdByInsightsUserId"] !== undefined ? _data["createdByInsightsUserId"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.source = _data["source"] !== undefined ? _data["source"] : <any>null;
            this.timestamp = _data["timestamp"] !== undefined ? _data["timestamp"] : <any>null;
            this.photoFull = _data["photoFull"] !== undefined ? _data["photoFull"] : <any>null;
            this.photoThumb = _data["photoThumb"] !== undefined ? _data["photoThumb"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.vendorName = _data["vendorName"] !== undefined ? _data["vendorName"] : <any>null;
            this.contactPerson = _data["contactPerson"] !== undefined ? _data["contactPerson"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.dataValidationNote = _data["dataValidationNote"] !== undefined ? _data["dataValidationNote"] : <any>null;
            this.lastValidationDate = _data["lastValidationDate"] ? new Date(_data["lastValidationDate"].toString()) : <any>null;
            this.hasDefaultWifiConfig = _data["hasDefaultWifiConfig"] !== undefined ? _data["hasDefaultWifiConfig"] : <any>null;
        }
    }

    static fromJS(data: any): Bar {
        data = typeof data === 'object' ? data : {};
        let result = new Bar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["advertiserId"] = this.advertiserId !== undefined ? this.advertiserId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lng"] = this.lng !== undefined ? this.lng : <any>null;
        data["officialAddress"] = this.officialAddress !== undefined ? this.officialAddress : <any>null;
        data["formattedAddress"] = this.formattedAddress !== undefined ? this.formattedAddress : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["streetAddress"] = this.streetAddress !== undefined ? this.streetAddress : <any>null;
        data["route"] = this.route !== undefined ? this.route : <any>null;
        data["streetNumber"] = this.streetNumber !== undefined ? this.streetNumber : <any>null;
        data["administrativeAreaL1"] = this.administrativeAreaL1 !== undefined ? this.administrativeAreaL1 : <any>null;
        data["administrativeAreaL1ShortName"] = this.administrativeAreaL1ShortName !== undefined ? this.administrativeAreaL1ShortName : <any>null;
        data["administrativeAreaL2"] = this.administrativeAreaL2 !== undefined ? this.administrativeAreaL2 : <any>null;
        data["administrativeAreaL2ShortName"] = this.administrativeAreaL2ShortName !== undefined ? this.administrativeAreaL2ShortName : <any>null;
        data["administrativeAreaL3"] = this.administrativeAreaL3 !== undefined ? this.administrativeAreaL3 : <any>null;
        data["administrativeAreaL3ShortName"] = this.administrativeAreaL3ShortName !== undefined ? this.administrativeAreaL3ShortName : <any>null;
        data["administrativeAreaL4"] = this.administrativeAreaL4 !== undefined ? this.administrativeAreaL4 : <any>null;
        data["administrativeAreaL4ShortName"] = this.administrativeAreaL4ShortName !== undefined ? this.administrativeAreaL4ShortName : <any>null;
        data["administrativeAreaL5"] = this.administrativeAreaL5 !== undefined ? this.administrativeAreaL5 : <any>null;
        data["administrativeAreaL5ShortName"] = this.administrativeAreaL5ShortName !== undefined ? this.administrativeAreaL5ShortName : <any>null;
        data["locality"] = this.locality !== undefined ? this.locality : <any>null;
        data["sublocality"] = this.sublocality !== undefined ? this.sublocality : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["neighborhood"] = this.neighborhood !== undefined ? this.neighborhood : <any>null;
        data["placeId"] = this.placeId !== undefined ? this.placeId : <any>null;
        data["plusCodeGlobal"] = this.plusCodeGlobal !== undefined ? this.plusCodeGlobal : <any>null;
        data["plusCodeLocal"] = this.plusCodeLocal !== undefined ? this.plusCodeLocal : <any>null;
        data["timeZoneId"] = this.timeZoneId !== undefined ? this.timeZoneId : <any>null;
        data["timeZoneName"] = this.timeZoneName !== undefined ? this.timeZoneName : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["insightsId"] = this.insightsId !== undefined ? this.insightsId : <any>null;
        data["slug"] = this.slug !== undefined ? this.slug : <any>null;
        data["createdByInsightsUserId"] = this.createdByInsightsUserId !== undefined ? this.createdByInsightsUserId : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["source"] = this.source !== undefined ? this.source : <any>null;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : <any>null;
        data["photoFull"] = this.photoFull !== undefined ? this.photoFull : <any>null;
        data["photoThumb"] = this.photoThumb !== undefined ? this.photoThumb : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["vendorName"] = this.vendorName !== undefined ? this.vendorName : <any>null;
        data["contactPerson"] = this.contactPerson !== undefined ? this.contactPerson : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["dataValidationNote"] = this.dataValidationNote !== undefined ? this.dataValidationNote : <any>null;
        data["lastValidationDate"] = this.lastValidationDate ? this.lastValidationDate.toISOString() : <any>null;
        data["hasDefaultWifiConfig"] = this.hasDefaultWifiConfig !== undefined ? this.hasDefaultWifiConfig : <any>null;
        return data;
    }
}

export interface IBar {
    id?: number | null;
    advertiserId?: string | null;
    name?: string | null;
    description?: string | null;
    organizationId?: number | null;
    lat?: number | null;
    lng?: number | null;
    officialAddress?: string | null;
    formattedAddress?: string | null;
    country?: string | null;
    countryCode?: string | null;
    streetAddress?: string | null;
    route?: string | null;
    streetNumber?: string | null;
    administrativeAreaL1?: string | null;
    administrativeAreaL1ShortName?: string | null;
    administrativeAreaL2?: string | null;
    administrativeAreaL2ShortName?: string | null;
    administrativeAreaL3?: string | null;
    administrativeAreaL3ShortName?: string | null;
    administrativeAreaL4?: string | null;
    administrativeAreaL4ShortName?: string | null;
    administrativeAreaL5?: string | null;
    administrativeAreaL5ShortName?: string | null;
    locality?: string | null;
    sublocality?: string | null;
    postalCode?: string | null;
    neighborhood?: string | null;
    placeId?: string | null;
    plusCodeGlobal?: string | null;
    plusCodeLocal?: string | null;
    timeZoneId?: string | null;
    timeZoneName?: string | null;
    state?: BarState | null;
    insightsId?: string | null;
    slug?: string | null;
    createdByInsightsUserId?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    source?: string | null;
    timestamp?: string | null;
    photoFull?: string | null;
    photoThumb?: string | null;
    externalId?: string | null;
    vendorName?: string | null;
    contactPerson?: string | null;
    email?: string | null;
    phone?: string | null;
    dataValidationNote?: string | null;
    lastValidationDate?: Date | null;
    hasDefaultWifiConfig?: boolean | null;
}

export class BarDistributionQueryResponse implements IBarDistributionQueryResponse {
    items?: DistributionBar[] | null;
    total?: number | null;
    nextToken?: string | null;

    constructor(data?: IBarDistributionQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DistributionBar.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
        }
    }

    static fromJS(data: any): BarDistributionQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BarDistributionQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        return data;
    }
}

export interface IBarDistributionQueryResponse {
    items?: DistributionBar[] | null;
    total?: number | null;
    nextToken?: string | null;
}

export class BarQuery implements IBarQuery {
    names?: string[] | null;
    state?: BarState | null;
    organizationId?: number | null;
    externalId?: string | null;
    vendorName?: string | null;
    administrativeAreaL1s?: string[] | null;
    administrativeAreaL2s?: string[] | null;
    skip?: number | null;
    maxItems?: number | null;
    nextToken?: string | null;

    constructor(data?: IBarQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(item);
            }
            else {
                this.names = <any>null;
            }
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.vendorName = _data["vendorName"] !== undefined ? _data["vendorName"] : <any>null;
            if (Array.isArray(_data["administrativeAreaL1s"])) {
                this.administrativeAreaL1s = [] as any;
                for (let item of _data["administrativeAreaL1s"])
                    this.administrativeAreaL1s!.push(item);
            }
            else {
                this.administrativeAreaL1s = <any>null;
            }
            if (Array.isArray(_data["administrativeAreaL2s"])) {
                this.administrativeAreaL2s = [] as any;
                for (let item of _data["administrativeAreaL2s"])
                    this.administrativeAreaL2s!.push(item);
            }
            else {
                this.administrativeAreaL2s = <any>null;
            }
            this.skip = _data["skip"] !== undefined ? _data["skip"] : <any>null;
            this.maxItems = _data["maxItems"] !== undefined ? _data["maxItems"] : <any>null;
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
        }
    }

    static fromJS(data: any): BarQuery {
        data = typeof data === 'object' ? data : {};
        let result = new BarQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item);
        }
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["vendorName"] = this.vendorName !== undefined ? this.vendorName : <any>null;
        if (Array.isArray(this.administrativeAreaL1s)) {
            data["administrativeAreaL1s"] = [];
            for (let item of this.administrativeAreaL1s)
                data["administrativeAreaL1s"].push(item);
        }
        if (Array.isArray(this.administrativeAreaL2s)) {
            data["administrativeAreaL2s"] = [];
            for (let item of this.administrativeAreaL2s)
                data["administrativeAreaL2s"].push(item);
        }
        data["skip"] = this.skip !== undefined ? this.skip : <any>null;
        data["maxItems"] = this.maxItems !== undefined ? this.maxItems : <any>null;
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        return data;
    }
}

export interface IBarQuery {
    names?: string[] | null;
    state?: BarState | null;
    organizationId?: number | null;
    externalId?: string | null;
    vendorName?: string | null;
    administrativeAreaL1s?: string[] | null;
    administrativeAreaL2s?: string[] | null;
    skip?: number | null;
    maxItems?: number | null;
    nextToken?: string | null;
}

export class BarQueryResponse implements IBarQueryResponse {
    items?: Bar[] | null;
    total?: number | null;
    nextToken?: string | null;

    constructor(data?: IBarQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Bar.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
        }
    }

    static fromJS(data: any): BarQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BarQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        return data;
    }
}

export interface IBarQueryResponse {
    items?: Bar[] | null;
    total?: number | null;
    nextToken?: string | null;
}

export enum BarState {
    ForReview = "ForReview",
    Validated = "Validated",
    NewVisible = "NewVisible",
    NewHidden = "NewHidden",
    ForDeletion = "ForDeletion",
}

export class CheckIn implements ICheckIn {
    id?: string | null;
    openerId?: string | null;
    barId?: string | null;
    userId?: string | null;
    checkInDate?: Date | null;
    checkOutDate?: Date | null;
    insightsId?: string | null;
    timestamp?: string | null;
    readonly isActive?: boolean | null;

    constructor(data?: ICheckIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.openerId = _data["openerId"] !== undefined ? _data["openerId"] : <any>null;
            this.barId = _data["barId"] !== undefined ? _data["barId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.checkInDate = _data["checkInDate"] ? new Date(_data["checkInDate"].toString()) : <any>null;
            this.checkOutDate = _data["checkOutDate"] ? new Date(_data["checkOutDate"].toString()) : <any>null;
            this.insightsId = _data["insightsId"] !== undefined ? _data["insightsId"] : <any>null;
            this.timestamp = _data["timestamp"] !== undefined ? _data["timestamp"] : <any>null;
            (<any>this).isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): CheckIn {
        data = typeof data === 'object' ? data : {};
        let result = new CheckIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["openerId"] = this.openerId !== undefined ? this.openerId : <any>null;
        data["barId"] = this.barId !== undefined ? this.barId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["checkInDate"] = this.checkInDate ? this.checkInDate.toISOString() : <any>null;
        data["checkOutDate"] = this.checkOutDate ? this.checkOutDate.toISOString() : <any>null;
        data["insightsId"] = this.insightsId !== undefined ? this.insightsId : <any>null;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ICheckIn {
    id?: string | null;
    openerId?: string | null;
    barId?: string | null;
    userId?: string | null;
    checkInDate?: Date | null;
    checkOutDate?: Date | null;
    insightsId?: string | null;
    timestamp?: string | null;
    isActive?: boolean | null;
}

export class CheckInContextResponse implements ICheckInContextResponse {
    /** Each check-in operation has an id. */
    id?: number | null;
    /** The opener that is checked in. */
    openerId?: string | null;
    bar?: Bar | null;
    /** The user id. */
    userId?: string | null;
    /** Gets/Sets when the check-in was created - the date when the check-in was "confirmed". */
    checkInDate?: Date | null;
    /** Gets/Sets when the check-out occured. If it didn't yet occur this value will be null. */
    checkOutDate?: Date | null;

    constructor(data?: ICheckInContextResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.openerId = _data["openerId"] !== undefined ? _data["openerId"] : <any>null;
            this.bar = _data["bar"] ? Bar.fromJS(_data["bar"]) : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.checkInDate = _data["checkInDate"] ? new Date(_data["checkInDate"].toString()) : <any>null;
            this.checkOutDate = _data["checkOutDate"] ? new Date(_data["checkOutDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): CheckInContextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckInContextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["openerId"] = this.openerId !== undefined ? this.openerId : <any>null;
        data["bar"] = this.bar ? this.bar.toJSON() : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["checkInDate"] = this.checkInDate ? this.checkInDate.toISOString() : <any>null;
        data["checkOutDate"] = this.checkOutDate ? this.checkOutDate.toISOString() : <any>null;
        return data;
    }
}

export interface ICheckInContextResponse {
    /** Each check-in operation has an id. */
    id?: number | null;
    /** The opener that is checked in. */
    openerId?: string | null;
    bar?: Bar | null;
    /** The user id. */
    userId?: string | null;
    /** Gets/Sets when the check-in was created - the date when the check-in was "confirmed". */
    checkInDate?: Date | null;
    /** Gets/Sets when the check-out occured. If it didn't yet occur this value will be null. */
    checkOutDate?: Date | null;
}

export class CheckInRequest implements ICheckInRequest {
    id?: string | null;
    openerId?: string | null;
    barId?: string | null;
    userId?: string | null;
    createDate?: Date | null;
    checkInId?: string | null;
    checkInDate?: Date | null;
    status?: CheckInRequestStatus | null;
    timestamp?: string | null;
    openerFlow?: string | null;

    constructor(data?: ICheckInRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.openerId = _data["openerId"] !== undefined ? _data["openerId"] : <any>null;
            this.barId = _data["barId"] !== undefined ? _data["barId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>null;
            this.checkInId = _data["checkInId"] !== undefined ? _data["checkInId"] : <any>null;
            this.checkInDate = _data["checkInDate"] ? new Date(_data["checkInDate"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.timestamp = _data["timestamp"] !== undefined ? _data["timestamp"] : <any>null;
            this.openerFlow = _data["openerFlow"] !== undefined ? _data["openerFlow"] : <any>null;
        }
    }

    static fromJS(data: any): CheckInRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckInRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["openerId"] = this.openerId !== undefined ? this.openerId : <any>null;
        data["barId"] = this.barId !== undefined ? this.barId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>null;
        data["checkInId"] = this.checkInId !== undefined ? this.checkInId : <any>null;
        data["checkInDate"] = this.checkInDate ? this.checkInDate.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : <any>null;
        data["openerFlow"] = this.openerFlow !== undefined ? this.openerFlow : <any>null;
        return data;
    }
}

export interface ICheckInRequest {
    id?: string | null;
    openerId?: string | null;
    barId?: string | null;
    userId?: string | null;
    createDate?: Date | null;
    checkInId?: string | null;
    checkInDate?: Date | null;
    status?: CheckInRequestStatus | null;
    timestamp?: string | null;
    openerFlow?: string | null;
}

export enum CheckInRequestStatus {
    Created = "Created",
    Validated = "Validated",
    Expired = "Expired",
}

export class ClientErrorMessageResponse implements IClientErrorMessageResponse {
    message?: string | null;

    constructor(data?: IClientErrorMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): ClientErrorMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientErrorMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data;
    }
}

export interface IClientErrorMessageResponse {
    message?: string | null;
}

/** Create meeting request */
export class CreateMeetingRequest implements ICreateMeetingRequest {
    /** Bar id */
    barId?: number | null;
    /** Latitude */
    lat?: number | null;
    /** Longitude */
    lng?: number | null;
    /** Participant id (aka the customer) */
    participantId?: string | null;
    /** Participant phone number */
    participantPhoneNo?: string | null;

    constructor(data?: ICreateMeetingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barId = _data["barId"] !== undefined ? _data["barId"] : <any>null;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : <any>null;
            this.participantId = _data["participantId"] !== undefined ? _data["participantId"] : <any>null;
            this.participantPhoneNo = _data["participantPhoneNo"] !== undefined ? _data["participantPhoneNo"] : <any>null;
        }
    }

    static fromJS(data: any): CreateMeetingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeetingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barId"] = this.barId !== undefined ? this.barId : <any>null;
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lng"] = this.lng !== undefined ? this.lng : <any>null;
        data["participantId"] = this.participantId !== undefined ? this.participantId : <any>null;
        data["participantPhoneNo"] = this.participantPhoneNo !== undefined ? this.participantPhoneNo : <any>null;
        return data;
    }
}

/** Create meeting request */
export interface ICreateMeetingRequest {
    /** Bar id */
    barId?: number | null;
    /** Latitude */
    lat?: number | null;
    /** Longitude */
    lng?: number | null;
    /** Participant id (aka the customer) */
    participantId?: string | null;
    /** Participant phone number */
    participantPhoneNo?: string | null;
}

export class CreateOrganizationAndOutletRequest implements ICreateOrganizationAndOutletRequest {
    organizationName?: string | null;
    organizationDescription?: string | null;
    outletName?: string | null;
    outletDescription?: string | null;
    advertiserId?: string | null;
    lat?: number | null;
    lng?: number | null;
    officialAddress?: string | null;

    constructor(data?: ICreateOrganizationAndOutletRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.organizationDescription = _data["organizationDescription"] !== undefined ? _data["organizationDescription"] : <any>null;
            this.outletName = _data["outletName"] !== undefined ? _data["outletName"] : <any>null;
            this.outletDescription = _data["outletDescription"] !== undefined ? _data["outletDescription"] : <any>null;
            this.advertiserId = _data["advertiserId"] !== undefined ? _data["advertiserId"] : <any>null;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : <any>null;
            this.officialAddress = _data["officialAddress"] !== undefined ? _data["officialAddress"] : <any>null;
        }
    }

    static fromJS(data: any): CreateOrganizationAndOutletRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationAndOutletRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["organizationDescription"] = this.organizationDescription !== undefined ? this.organizationDescription : <any>null;
        data["outletName"] = this.outletName !== undefined ? this.outletName : <any>null;
        data["outletDescription"] = this.outletDescription !== undefined ? this.outletDescription : <any>null;
        data["advertiserId"] = this.advertiserId !== undefined ? this.advertiserId : <any>null;
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lng"] = this.lng !== undefined ? this.lng : <any>null;
        data["officialAddress"] = this.officialAddress !== undefined ? this.officialAddress : <any>null;
        return data;
    }
}

export interface ICreateOrganizationAndOutletRequest {
    organizationName?: string | null;
    organizationDescription?: string | null;
    outletName?: string | null;
    outletDescription?: string | null;
    advertiserId?: string | null;
    lat?: number | null;
    lng?: number | null;
    officialAddress?: string | null;
}

export class CreateOrganizationRequest implements ICreateOrganizationRequest {
    id?: number | null;
    name?: string | null;
    description?: string | null;
    externalId?: string | null;

    constructor(data?: ICreateOrganizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateOrganizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        return data;
    }
}

export interface ICreateOrganizationRequest {
    id?: number | null;
    name?: string | null;
    description?: string | null;
    externalId?: string | null;
}

export class CreateStaffInvitationRequest implements ICreateStaffInvitationRequest {
    organizationId?: number | null;
    organizationOwnerAccountId?: string | null;
    validUntil?: Date | null;
    barId?: number | null;

    constructor(data?: ICreateStaffInvitationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.organizationOwnerAccountId = _data["organizationOwnerAccountId"] !== undefined ? _data["organizationOwnerAccountId"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.barId = _data["barId"] !== undefined ? _data["barId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateStaffInvitationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffInvitationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["organizationOwnerAccountId"] = this.organizationOwnerAccountId !== undefined ? this.organizationOwnerAccountId : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["barId"] = this.barId !== undefined ? this.barId : <any>null;
        return data;
    }
}

export interface ICreateStaffInvitationRequest {
    organizationId?: number | null;
    organizationOwnerAccountId?: string | null;
    validUntil?: Date | null;
    barId?: number | null;
}

export class Device implements IDevice {
    name?: string | null;
    type?: string | null;
    attributes?: DeviceAttributes | null;
    status?: DeviceStatus | null;
    isConnected?: boolean | null;
    pendingOTAUpdate?: boolean | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    version?: number | null;

    constructor(data?: IDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.attributes = _data["attributes"] ? DeviceAttributes.fromJS(_data["attributes"]) : <any>null;
            this.status = _data["status"] ? DeviceStatus.fromJS(_data["status"]) : <any>null;
            this.isConnected = _data["isConnected"] !== undefined ? _data["isConnected"] : <any>null;
            this.pendingOTAUpdate = _data["pendingOTAUpdate"] !== undefined ? _data["pendingOTAUpdate"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
        }
    }

    static fromJS(data: any): Device {
        data = typeof data === 'object' ? data : {};
        let result = new Device();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["attributes"] = this.attributes ? this.attributes.toJSON() : <any>null;
        data["status"] = this.status ? this.status.toJSON() : <any>null;
        data["isConnected"] = this.isConnected !== undefined ? this.isConnected : <any>null;
        data["pendingOTAUpdate"] = this.pendingOTAUpdate !== undefined ? this.pendingOTAUpdate : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        return data;
    }
}

export interface IDevice {
    name?: string | null;
    type?: string | null;
    attributes?: DeviceAttributes | null;
    status?: DeviceStatus | null;
    isConnected?: boolean | null;
    pendingOTAUpdate?: boolean | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    version?: number | null;
}

export class DeviceAttributes implements IDeviceAttributes {
    macAddress?: string | null;
    hpi?: string | null;
    qcDate?: Date | null;
    lifeCycleStatus?: string | null;
    createdAt?: Date | null;
    environment?: string | null;
    openerGroup?: string | null;
    outletId?: string | null;
    advertiserId?: string | null;

    constructor(data?: IDeviceAttributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.macAddress = _data["macAddress"] !== undefined ? _data["macAddress"] : <any>null;
            this.hpi = _data["hpi"] !== undefined ? _data["hpi"] : <any>null;
            this.qcDate = _data["qcDate"] ? new Date(_data["qcDate"].toString()) : <any>null;
            this.lifeCycleStatus = _data["lifeCycleStatus"] !== undefined ? _data["lifeCycleStatus"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.environment = _data["environment"] !== undefined ? _data["environment"] : <any>null;
            this.openerGroup = _data["openerGroup"] !== undefined ? _data["openerGroup"] : <any>null;
            this.outletId = _data["outletId"] !== undefined ? _data["outletId"] : <any>null;
            this.advertiserId = _data["advertiserId"] !== undefined ? _data["advertiserId"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceAttributes {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceAttributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["macAddress"] = this.macAddress !== undefined ? this.macAddress : <any>null;
        data["hpi"] = this.hpi !== undefined ? this.hpi : <any>null;
        data["qcDate"] = this.qcDate ? this.qcDate.toISOString() : <any>null;
        data["lifeCycleStatus"] = this.lifeCycleStatus !== undefined ? this.lifeCycleStatus : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["environment"] = this.environment !== undefined ? this.environment : <any>null;
        data["openerGroup"] = this.openerGroup !== undefined ? this.openerGroup : <any>null;
        data["outletId"] = this.outletId !== undefined ? this.outletId : <any>null;
        data["advertiserId"] = this.advertiserId !== undefined ? this.advertiserId : <any>null;
        return data;
    }
}

export interface IDeviceAttributes {
    macAddress?: string | null;
    hpi?: string | null;
    qcDate?: Date | null;
    lifeCycleStatus?: string | null;
    createdAt?: Date | null;
    environment?: string | null;
    openerGroup?: string | null;
    outletId?: string | null;
    advertiserId?: string | null;
}

export class DeviceFilters implements IDeviceFilters {
    seriaNumber?: string[] | null;
    mac?: string[] | null;
    hpi?: string[] | null;
    currentFirmware?: string[] | null;
    desiredFirmware?: string[] | null;
    isFirmwareUpdated?: boolean | null;
    imagesRemaining?: number | null;
    outletId?: string | null;
    advertiserId?: string | null;
    pageSize?: number | null;
    nextToken?: string | null;
    fromDate?: Date | null;

    constructor(data?: IDeviceFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["seriaNumber"])) {
                this.seriaNumber = [] as any;
                for (let item of _data["seriaNumber"])
                    this.seriaNumber!.push(item);
            }
            else {
                this.seriaNumber = <any>null;
            }
            if (Array.isArray(_data["mac"])) {
                this.mac = [] as any;
                for (let item of _data["mac"])
                    this.mac!.push(item);
            }
            else {
                this.mac = <any>null;
            }
            if (Array.isArray(_data["hpi"])) {
                this.hpi = [] as any;
                for (let item of _data["hpi"])
                    this.hpi!.push(item);
            }
            else {
                this.hpi = <any>null;
            }
            if (Array.isArray(_data["currentFirmware"])) {
                this.currentFirmware = [] as any;
                for (let item of _data["currentFirmware"])
                    this.currentFirmware!.push(item);
            }
            else {
                this.currentFirmware = <any>null;
            }
            if (Array.isArray(_data["desiredFirmware"])) {
                this.desiredFirmware = [] as any;
                for (let item of _data["desiredFirmware"])
                    this.desiredFirmware!.push(item);
            }
            else {
                this.desiredFirmware = <any>null;
            }
            this.isFirmwareUpdated = _data["isFirmwareUpdated"] !== undefined ? _data["isFirmwareUpdated"] : <any>null;
            this.imagesRemaining = _data["imagesRemaining"] !== undefined ? _data["imagesRemaining"] : <any>null;
            this.outletId = _data["outletId"] !== undefined ? _data["outletId"] : <any>null;
            this.advertiserId = _data["advertiserId"] !== undefined ? _data["advertiserId"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DeviceFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.seriaNumber)) {
            data["seriaNumber"] = [];
            for (let item of this.seriaNumber)
                data["seriaNumber"].push(item);
        }
        if (Array.isArray(this.mac)) {
            data["mac"] = [];
            for (let item of this.mac)
                data["mac"].push(item);
        }
        if (Array.isArray(this.hpi)) {
            data["hpi"] = [];
            for (let item of this.hpi)
                data["hpi"].push(item);
        }
        if (Array.isArray(this.currentFirmware)) {
            data["currentFirmware"] = [];
            for (let item of this.currentFirmware)
                data["currentFirmware"].push(item);
        }
        if (Array.isArray(this.desiredFirmware)) {
            data["desiredFirmware"] = [];
            for (let item of this.desiredFirmware)
                data["desiredFirmware"].push(item);
        }
        data["isFirmwareUpdated"] = this.isFirmwareUpdated !== undefined ? this.isFirmwareUpdated : <any>null;
        data["imagesRemaining"] = this.imagesRemaining !== undefined ? this.imagesRemaining : <any>null;
        data["outletId"] = this.outletId !== undefined ? this.outletId : <any>null;
        data["advertiserId"] = this.advertiserId !== undefined ? this.advertiserId : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>null;
        return data;
    }
}

export interface IDeviceFilters {
    seriaNumber?: string[] | null;
    mac?: string[] | null;
    hpi?: string[] | null;
    currentFirmware?: string[] | null;
    desiredFirmware?: string[] | null;
    isFirmwareUpdated?: boolean | null;
    imagesRemaining?: number | null;
    outletId?: string | null;
    advertiserId?: string | null;
    pageSize?: number | null;
    nextToken?: string | null;
    fromDate?: Date | null;
}

export class DeviceStatus implements IDeviceStatus {
    reported?: DeviceStatusReported | null;
    desired?: DeviceStatusDesired | null;
    shadowVersion?: number | null;
    timestamp?: Date | null;
    reportedFirmwareTimestamp?: Date | null;

    constructor(data?: IDeviceStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reported = _data["reported"] ? DeviceStatusReported.fromJS(_data["reported"]) : <any>null;
            this.desired = _data["desired"] ? DeviceStatusDesired.fromJS(_data["desired"]) : <any>null;
            this.shadowVersion = _data["shadowVersion"] !== undefined ? _data["shadowVersion"] : <any>null;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>null;
            this.reportedFirmwareTimestamp = _data["reportedFirmwareTimestamp"] ? new Date(_data["reportedFirmwareTimestamp"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DeviceStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reported"] = this.reported ? this.reported.toJSON() : <any>null;
        data["desired"] = this.desired ? this.desired.toJSON() : <any>null;
        data["shadowVersion"] = this.shadowVersion !== undefined ? this.shadowVersion : <any>null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["reportedFirmwareTimestamp"] = this.reportedFirmwareTimestamp ? this.reportedFirmwareTimestamp.toISOString() : <any>null;
        return data;
    }
}

export interface IDeviceStatus {
    reported?: DeviceStatusReported | null;
    desired?: DeviceStatusDesired | null;
    shadowVersion?: number | null;
    timestamp?: Date | null;
    reportedFirmwareTimestamp?: Date | null;
}

export class DeviceStatusDesired implements IDeviceStatusDesired {
    firmwareId?: string | null;
    firmware?: string | null;

    constructor(data?: IDeviceStatusDesired) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firmwareId = _data["firmwareId"] !== undefined ? _data["firmwareId"] : <any>null;
            this.firmware = _data["firmware"] !== undefined ? _data["firmware"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceStatusDesired {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStatusDesired();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firmwareId"] = this.firmwareId !== undefined ? this.firmwareId : <any>null;
        data["firmware"] = this.firmware !== undefined ? this.firmware : <any>null;
        return data;
    }
}

export interface IDeviceStatusDesired {
    firmwareId?: string | null;
    firmware?: string | null;
}

export class DeviceStatusReported implements IDeviceStatusReported {
    firmware?: string | null;
    captureTime?: Date | null;
    lastConnect?: Date | null;
    deviceTime?: Date | null;
    batteryLevel?: number | null;
    imageRemaining?: number | null;
    imageSerialNumber?: number | null;
    totalImagesCount?: number | null;
    connection?: string | null;
    wifiTime?: number | null;
    rssi?: number | null;

    constructor(data?: IDeviceStatusReported) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firmware = _data["firmware"] !== undefined ? _data["firmware"] : <any>null;
            this.captureTime = _data["captureTime"] ? new Date(_data["captureTime"].toString()) : <any>null;
            this.lastConnect = _data["lastConnect"] ? new Date(_data["lastConnect"].toString()) : <any>null;
            this.deviceTime = _data["deviceTime"] ? new Date(_data["deviceTime"].toString()) : <any>null;
            this.batteryLevel = _data["batteryLevel"] !== undefined ? _data["batteryLevel"] : <any>null;
            this.imageRemaining = _data["imageRemaining"] !== undefined ? _data["imageRemaining"] : <any>null;
            this.imageSerialNumber = _data["imageSerialNumber"] !== undefined ? _data["imageSerialNumber"] : <any>null;
            this.totalImagesCount = _data["totalImagesCount"] !== undefined ? _data["totalImagesCount"] : <any>null;
            this.connection = _data["connection"] !== undefined ? _data["connection"] : <any>null;
            this.wifiTime = _data["wifiTime"] !== undefined ? _data["wifiTime"] : <any>null;
            this.rssi = _data["rssi"] !== undefined ? _data["rssi"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceStatusReported {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStatusReported();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firmware"] = this.firmware !== undefined ? this.firmware : <any>null;
        data["captureTime"] = this.captureTime ? this.captureTime.toISOString() : <any>null;
        data["lastConnect"] = this.lastConnect ? this.lastConnect.toISOString() : <any>null;
        data["deviceTime"] = this.deviceTime ? this.deviceTime.toISOString() : <any>null;
        data["batteryLevel"] = this.batteryLevel !== undefined ? this.batteryLevel : <any>null;
        data["imageRemaining"] = this.imageRemaining !== undefined ? this.imageRemaining : <any>null;
        data["imageSerialNumber"] = this.imageSerialNumber !== undefined ? this.imageSerialNumber : <any>null;
        data["totalImagesCount"] = this.totalImagesCount !== undefined ? this.totalImagesCount : <any>null;
        data["connection"] = this.connection !== undefined ? this.connection : <any>null;
        data["wifiTime"] = this.wifiTime !== undefined ? this.wifiTime : <any>null;
        data["rssi"] = this.rssi !== undefined ? this.rssi : <any>null;
        return data;
    }
}

export interface IDeviceStatusReported {
    firmware?: string | null;
    captureTime?: Date | null;
    lastConnect?: Date | null;
    deviceTime?: Date | null;
    batteryLevel?: number | null;
    imageRemaining?: number | null;
    imageSerialNumber?: number | null;
    totalImagesCount?: number | null;
    connection?: string | null;
    wifiTime?: number | null;
    rssi?: number | null;
}

export class DistributionBar implements IDistributionBar {
    id?: number | null;
    photoFull?: string | null;
    name?: string | null;
    country?: string | null;
    administrativeAreaL1?: string | null;
    administrativeAreaL2?: string | null;
    sublocality?: string | null;
    externalId?: string | null;
    formattedAddress?: string | null;
    organizationId?: number | null;

    constructor(data?: IDistributionBar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.photoFull = _data["photoFull"] !== undefined ? _data["photoFull"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.administrativeAreaL1 = _data["administrativeAreaL1"] !== undefined ? _data["administrativeAreaL1"] : <any>null;
            this.administrativeAreaL2 = _data["administrativeAreaL2"] !== undefined ? _data["administrativeAreaL2"] : <any>null;
            this.sublocality = _data["sublocality"] !== undefined ? _data["sublocality"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.formattedAddress = _data["formattedAddress"] !== undefined ? _data["formattedAddress"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
        }
    }

    static fromJS(data: any): DistributionBar {
        data = typeof data === 'object' ? data : {};
        let result = new DistributionBar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["photoFull"] = this.photoFull !== undefined ? this.photoFull : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["administrativeAreaL1"] = this.administrativeAreaL1 !== undefined ? this.administrativeAreaL1 : <any>null;
        data["administrativeAreaL2"] = this.administrativeAreaL2 !== undefined ? this.administrativeAreaL2 : <any>null;
        data["sublocality"] = this.sublocality !== undefined ? this.sublocality : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["formattedAddress"] = this.formattedAddress !== undefined ? this.formattedAddress : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        return data;
    }
}

export interface IDistributionBar {
    id?: number | null;
    photoFull?: string | null;
    name?: string | null;
    country?: string | null;
    administrativeAreaL1?: string | null;
    administrativeAreaL2?: string | null;
    sublocality?: string | null;
    externalId?: string | null;
    formattedAddress?: string | null;
    organizationId?: number | null;
}

export class FleetIndexResponse implements IFleetIndexResponse {
    data?: Device[] | null;
    nextToken?: string | null;

    constructor(data?: IFleetIndexResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Device.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
        }
    }

    static fromJS(data: any): FleetIndexResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FleetIndexResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        return data;
    }
}

export interface IFleetIndexResponse {
    data?: Device[] | null;
    nextToken?: string | null;
}

export class Geometry implements IGeometry {
    location?: Location | null;
    bounds?: ViewPort | null;
    viewport?: ViewPort | null;
    location_type?: GeometryLocationType | null;

    constructor(data?: IGeometry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>null;
            this.bounds = _data["bounds"] ? ViewPort.fromJS(_data["bounds"]) : <any>null;
            this.viewport = _data["viewport"] ? ViewPort.fromJS(_data["viewport"]) : <any>null;
            this.location_type = _data["location_type"] !== undefined ? _data["location_type"] : <any>null;
        }
    }

    static fromJS(data: any): Geometry {
        data = typeof data === 'object' ? data : {};
        let result = new Geometry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : <any>null;
        data["bounds"] = this.bounds ? this.bounds.toJSON() : <any>null;
        data["viewport"] = this.viewport ? this.viewport.toJSON() : <any>null;
        data["location_type"] = this.location_type !== undefined ? this.location_type : <any>null;
        return data;
    }
}

export interface IGeometry {
    location?: Location | null;
    bounds?: ViewPort | null;
    viewport?: ViewPort | null;
    location_type?: GeometryLocationType | null;
}

export enum GeometryLocationType {
    ROOFTOP = "ROOFTOP",
    RANGE_INTERPOLATED = "RANGE_INTERPOLATED",
    GEOMETRIC_CENTER = "GEOMETRIC_CENTER",
    APPROXIMATE = "APPROXIMATE",
}

export class GetPagedLocationsByOrganizationIdRequest implements IGetPagedLocationsByOrganizationIdRequest {
    organizationId?: number | null;
    pageSize?: number | null;
    skip?: number | null;

    constructor(data?: IGetPagedLocationsByOrganizationIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.skip = _data["skip"] !== undefined ? _data["skip"] : <any>null;
        }
    }

    static fromJS(data: any): GetPagedLocationsByOrganizationIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPagedLocationsByOrganizationIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["skip"] = this.skip !== undefined ? this.skip : <any>null;
        return data;
    }
}

export interface IGetPagedLocationsByOrganizationIdRequest {
    organizationId?: number | null;
    pageSize?: number | null;
    skip?: number | null;
}

export class Item implements IItem {
    id?: number | null;
    name?: string | null;

    constructor(data?: IItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): Item {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IItem {
    id?: number | null;
    name?: string | null;
}

/** Join meeting request */
export class JoinMeetingRequest implements IJoinMeetingRequest {
    /** Meeting id. Can be null, but MeetingCode must be supplied in this case. */
    meetingId?: number | null;
    /** Meeting code */
    meetingCode?: string | null;
    /** Latitude */
    lat?: number | null;
    /** Longitude */
    lng?: number | null;

    constructor(data?: IJoinMeetingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingId = _data["meetingId"] !== undefined ? _data["meetingId"] : <any>null;
            this.meetingCode = _data["meetingCode"] !== undefined ? _data["meetingCode"] : <any>null;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : <any>null;
        }
    }

    static fromJS(data: any): JoinMeetingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new JoinMeetingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingId"] = this.meetingId !== undefined ? this.meetingId : <any>null;
        data["meetingCode"] = this.meetingCode !== undefined ? this.meetingCode : <any>null;
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lng"] = this.lng !== undefined ? this.lng : <any>null;
        return data;
    }
}

/** Join meeting request */
export interface IJoinMeetingRequest {
    /** Meeting id. Can be null, but MeetingCode must be supplied in this case. */
    meetingId?: number | null;
    /** Meeting code */
    meetingCode?: string | null;
    /** Latitude */
    lat?: number | null;
    /** Longitude */
    lng?: number | null;
}

export class Location implements ILocation {
    lat?: number | null;
    lng?: number | null;
    address?: string | null;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lng"] = this.lng !== undefined ? this.lng : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        return data;
    }
}

export interface ILocation {
    lat?: number | null;
    lng?: number | null;
    address?: string | null;
}

export class MapAddressComponent implements IMapAddressComponent {
    longName?: string | null;
    shortName?: string | null;
    types?: string[] | null;

    constructor(data?: IMapAddressComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.longName = _data["longName"] !== undefined ? _data["longName"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            else {
                this.types = <any>null;
            }
        }
    }

    static fromJS(data: any): MapAddressComponent {
        data = typeof data === 'object' ? data : {};
        let result = new MapAddressComponent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["longName"] = this.longName !== undefined ? this.longName : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }
}

export interface IMapAddressComponent {
    longName?: string | null;
    shortName?: string | null;
    types?: string[] | null;
}

export enum MatchAlgorithmEnum {
    Ratio = "Ratio",
    PartialRatio = "PartialRatio",
    TokenSortPartialRatio = "TokenSortPartialRatio",
    TokenSortRatio = "TokenSortRatio",
    TokenSetPartialRatio = "TokenSetPartialRatio",
    TokenSetRatio = "TokenSetRatio",
    WeightedRatio = "WeightedRatio",
}

export class Meeting implements IMeeting {
    id?: number | null;
    code?: string | null;
    barId?: number | null;
    ownerId?: string | null;
    ownerName?: string | null;
    ownerPhoneNo?: string | null;
    ownerCountryCode?: string | null;
    participantUserId?: string | null;
    participantPhoneNumber?: string | null;
    startedAt?: Date | null;
    joinedAt?: Date | null;
    endedAt?: Date | null;
    leftAt?: Date | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    timestamp?: string | null;

    constructor(data?: IMeeting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.barId = _data["barId"] !== undefined ? _data["barId"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.ownerName = _data["ownerName"] !== undefined ? _data["ownerName"] : <any>null;
            this.ownerPhoneNo = _data["ownerPhoneNo"] !== undefined ? _data["ownerPhoneNo"] : <any>null;
            this.ownerCountryCode = _data["ownerCountryCode"] !== undefined ? _data["ownerCountryCode"] : <any>null;
            this.participantUserId = _data["participantUserId"] !== undefined ? _data["participantUserId"] : <any>null;
            this.participantPhoneNumber = _data["participantPhoneNumber"] !== undefined ? _data["participantPhoneNumber"] : <any>null;
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>null;
            this.joinedAt = _data["joinedAt"] ? new Date(_data["joinedAt"].toString()) : <any>null;
            this.endedAt = _data["endedAt"] ? new Date(_data["endedAt"].toString()) : <any>null;
            this.leftAt = _data["leftAt"] ? new Date(_data["leftAt"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.timestamp = _data["timestamp"] !== undefined ? _data["timestamp"] : <any>null;
        }
    }

    static fromJS(data: any): Meeting {
        data = typeof data === 'object' ? data : {};
        let result = new Meeting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["barId"] = this.barId !== undefined ? this.barId : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["ownerName"] = this.ownerName !== undefined ? this.ownerName : <any>null;
        data["ownerPhoneNo"] = this.ownerPhoneNo !== undefined ? this.ownerPhoneNo : <any>null;
        data["ownerCountryCode"] = this.ownerCountryCode !== undefined ? this.ownerCountryCode : <any>null;
        data["participantUserId"] = this.participantUserId !== undefined ? this.participantUserId : <any>null;
        data["participantPhoneNumber"] = this.participantPhoneNumber !== undefined ? this.participantPhoneNumber : <any>null;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>null;
        data["joinedAt"] = this.joinedAt ? this.joinedAt.toISOString() : <any>null;
        data["endedAt"] = this.endedAt ? this.endedAt.toISOString() : <any>null;
        data["leftAt"] = this.leftAt ? this.leftAt.toISOString() : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : <any>null;
        return data;
    }
}

export interface IMeeting {
    id?: number | null;
    code?: string | null;
    barId?: number | null;
    ownerId?: string | null;
    ownerName?: string | null;
    ownerPhoneNo?: string | null;
    ownerCountryCode?: string | null;
    participantUserId?: string | null;
    participantPhoneNumber?: string | null;
    startedAt?: Date | null;
    joinedAt?: Date | null;
    endedAt?: Date | null;
    leftAt?: Date | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    timestamp?: string | null;
}

export class Organization implements IOrganization {
    id?: number | null;
    advertiserId?: string | null;
    name?: string | null;
    description?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    timestamp?: string | null;
    photoFull?: string | null;
    photoThumb?: string | null;
    externalId?: string | null;

    constructor(data?: IOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.advertiserId = _data["advertiserId"] !== undefined ? _data["advertiserId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.timestamp = _data["timestamp"] !== undefined ? _data["timestamp"] : <any>null;
            this.photoFull = _data["photoFull"] !== undefined ? _data["photoFull"] : <any>null;
            this.photoThumb = _data["photoThumb"] !== undefined ? _data["photoThumb"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
        }
    }

    static fromJS(data: any): Organization {
        data = typeof data === 'object' ? data : {};
        let result = new Organization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["advertiserId"] = this.advertiserId !== undefined ? this.advertiserId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : <any>null;
        data["photoFull"] = this.photoFull !== undefined ? this.photoFull : <any>null;
        data["photoThumb"] = this.photoThumb !== undefined ? this.photoThumb : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        return data;
    }
}

export interface IOrganization {
    id?: number | null;
    advertiserId?: string | null;
    name?: string | null;
    description?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    timestamp?: string | null;
    photoFull?: string | null;
    photoThumb?: string | null;
    externalId?: string | null;
}

export class OrganizationQuery implements IOrganizationQuery {
    names?: string[] | null;
    tags?: TagQueryItem[] | null;
    externalId?: string | null;
    skip?: number | null;
    maxItems?: number | null;
    nextToken?: string | null;
    advertiserId?: string | null;

    constructor(data?: IOrganizationQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(item);
            }
            else {
                this.names = <any>null;
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagQueryItem.fromJS(item));
            }
            else {
                this.tags = <any>null;
            }
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.skip = _data["skip"] !== undefined ? _data["skip"] : <any>null;
            this.maxItems = _data["maxItems"] !== undefined ? _data["maxItems"] : <any>null;
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
            this.advertiserId = _data["advertiserId"] !== undefined ? _data["advertiserId"] : <any>null;
        }
    }

    static fromJS(data: any): OrganizationQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["skip"] = this.skip !== undefined ? this.skip : <any>null;
        data["maxItems"] = this.maxItems !== undefined ? this.maxItems : <any>null;
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        data["advertiserId"] = this.advertiserId !== undefined ? this.advertiserId : <any>null;
        return data;
    }
}

export interface IOrganizationQuery {
    names?: string[] | null;
    tags?: TagQueryItem[] | null;
    externalId?: string | null;
    skip?: number | null;
    maxItems?: number | null;
    nextToken?: string | null;
    advertiserId?: string | null;
}

export class OrganizationQueryResponse implements IOrganizationQueryResponse {
    items?: Organization[] | null;
    total?: number | null;
    nextToken?: string | null;

    constructor(data?: IOrganizationQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Organization.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
        }
    }

    static fromJS(data: any): OrganizationQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        return data;
    }
}

export interface IOrganizationQueryResponse {
    items?: Organization[] | null;
    total?: number | null;
    nextToken?: string | null;
}

export class OrganizationTag implements IOrganizationTag {
    id?: string | null;
    organizationId?: number | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    tag?: string | null;
    value?: string | null;

    constructor(data?: IOrganizationTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): OrganizationTag {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IOrganizationTag {
    id?: string | null;
    organizationId?: number | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    tag?: string | null;
    value?: string | null;
}

export class OutletVendor implements IOutletVendor {
    id?: number | null;
    barId?: number | null;
    organizationId?: number | null;
    wildCard?: string | null;
    algorithm?: MatchAlgorithmEnum | null;
    fuzzyTreshold?: number | null;
    displayOrder?: number | null;

    constructor(data?: IOutletVendor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.barId = _data["barId"] !== undefined ? _data["barId"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.wildCard = _data["wildCard"] !== undefined ? _data["wildCard"] : <any>null;
            this.algorithm = _data["algorithm"] !== undefined ? _data["algorithm"] : <any>null;
            this.fuzzyTreshold = _data["fuzzyTreshold"] !== undefined ? _data["fuzzyTreshold"] : <any>null;
            this.displayOrder = _data["displayOrder"] !== undefined ? _data["displayOrder"] : <any>null;
        }
    }

    static fromJS(data: any): OutletVendor {
        data = typeof data === 'object' ? data : {};
        let result = new OutletVendor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["barId"] = this.barId !== undefined ? this.barId : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["wildCard"] = this.wildCard !== undefined ? this.wildCard : <any>null;
        data["algorithm"] = this.algorithm !== undefined ? this.algorithm : <any>null;
        data["fuzzyTreshold"] = this.fuzzyTreshold !== undefined ? this.fuzzyTreshold : <any>null;
        data["displayOrder"] = this.displayOrder !== undefined ? this.displayOrder : <any>null;
        return data;
    }
}

export interface IOutletVendor {
    id?: number | null;
    barId?: number | null;
    organizationId?: number | null;
    wildCard?: string | null;
    algorithm?: MatchAlgorithmEnum | null;
    fuzzyTreshold?: number | null;
    displayOrder?: number | null;
}

export class OutletVendorQuery implements IOutletVendorQuery {
    organizationId?: number | null;
    locationId?: number | null;
    skip?: number | null;
    maxItems?: number | null;
    nextToken?: string | null;

    constructor(data?: IOutletVendorQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : <any>null;
            this.skip = _data["skip"] !== undefined ? _data["skip"] : <any>null;
            this.maxItems = _data["maxItems"] !== undefined ? _data["maxItems"] : <any>null;
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
        }
    }

    static fromJS(data: any): OutletVendorQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OutletVendorQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["locationId"] = this.locationId !== undefined ? this.locationId : <any>null;
        data["skip"] = this.skip !== undefined ? this.skip : <any>null;
        data["maxItems"] = this.maxItems !== undefined ? this.maxItems : <any>null;
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        return data;
    }
}

export interface IOutletVendorQuery {
    organizationId?: number | null;
    locationId?: number | null;
    skip?: number | null;
    maxItems?: number | null;
    nextToken?: string | null;
}

export class OutletVendorQueryResponse implements IOutletVendorQueryResponse {
    items?: OutletVendor[] | null;
    total?: number | null;
    nextToken?: string | null;

    constructor(data?: IOutletVendorQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OutletVendor.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
        }
    }

    static fromJS(data: any): OutletVendorQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OutletVendorQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        return data;
    }
}

export interface IOutletVendorQueryResponse {
    items?: OutletVendor[] | null;
    total?: number | null;
    nextToken?: string | null;
}

export enum PlaceLocationType {
    Unknown = "unknown",
    Geocode = "geocode",
    Street_address = "street_address",
    Route = "route",
    Intersection = "intersection",
    Political = "political",
    Country = "country",
    Administrative_area_level_1 = "administrative_area_level_1",
    Administrative_area_level_2 = "administrative_area_level_2",
    Administrative_area_level_3 = "administrative_area_level_3",
    Administrative_area_level_4 = "administrative_area_level_4",
    Administrative_area_level_5 = "administrative_area_level_5",
    Colloquial_area = "colloquial_area",
    Locality = "locality",
    Sublocality = "sublocality",
    Sublocality_level_1 = "sublocality_level_1",
    Sublocality_level_2 = "sublocality_level_2",
    Sublocality_level_3 = "sublocality_level_3",
    Sublocality_level_4 = "sublocality_level_4",
    Sublocality_level_5 = "sublocality_level_5",
    Neighborhood = "neighborhood",
    Premise = "premise",
    Subpremise = "subpremise",
    Postal_code = "postal_code",
    Postal_code_prefix = "postal_code_prefix",
    Postal_code_suffix = "postal_code_suffix",
    Natural_feature = "natural_feature",
    Point_of_interest = "point_of_interest",
    Floor = "floor",
    Post_box = "post_box",
    Postal_town = "postal_town",
    Room = "room",
    Street_number = "street_number",
    Transit_station = "transit_station",
    Accounting = "accounting",
    Airport = "airport",
    Amusement_park = "amusement_park",
    Aquarium = "aquarium",
    Art_gallery = "art_gallery",
    Atm = "atm",
    Bakery = "bakery",
    Bank = "bank",
    Bar = "bar",
    Beauty_salon = "beauty_salon",
    Bicycle_store = "bicycle_store",
    Book_store = "book_store",
    Bowling_alley = "bowling_alley",
    Bus_station = "bus_station",
    Cafe = "cafe",
    Campground = "campground",
    Car_dealer = "car_dealer",
    Car_rental = "car_rental",
    Car_repair = "car_repair",
    Car_wash = "car_wash",
    Casino = "casino",
    Cemetery = "cemetery",
    Church = "church",
    City_hall = "city_hall",
    Clothing_store = "clothing_store",
    Convenience_store = "convenience_store",
    Courthouse = "courthouse",
    Dentist = "dentist",
    Department_store = "department_store",
    Doctor = "doctor",
    Electrician = "electrician",
    Electronics_store = "electronics_store",
    Embassy = "embassy",
    Establishment = "establishment",
    Finance = "finance",
    Fire_station = "fire_station",
    Florist = "florist",
    Food = "food",
    Funeral_home = "funeral_home",
    Furniture_store = "furniture_store",
    Gas_station = "gas_station",
    General_contractor = "general_contractor",
    Supermarket = "supermarket",
    Grocery_or_supermarket = "grocery_or_supermarket",
    Gym = "gym",
    Hair_care = "hair_care",
    Hardware_store = "hardware_store",
    Health = "health",
    Hindu_temple = "hindu_temple",
    Home_goods_store = "home_goods_store",
    Hospital = "hospital",
    Insurance_agency = "insurance_agency",
    Jewelry_store = "jewelry_store",
    Laundry = "laundry",
    Lawyer = "lawyer",
    Library = "library",
    Liquor_store = "liquor_store",
    Local_government_office = "local_government_office",
    Locksmith = "locksmith",
    Lodging = "lodging",
    Meal_delivery = "meal_delivery",
    Meal_takeaway = "meal_takeaway",
    Mosque = "mosque",
    Movie_rental = "movie_rental",
    Movie_theater = "movie_theater",
    Moving_company = "moving_company",
    Museum = "museum",
    Night_club = "night_club",
    Painter = "painter",
    Park = "park",
    Parking = "parking",
    Pet_store = "pet_store",
    Pharmacy = "pharmacy",
    Physiotherapist = "physiotherapist",
    Place_of_worship = "place_of_worship",
    Plumber = "plumber",
    Police = "police",
    Post_office = "post_office",
    Real_estate_agency = "real_estate_agency",
    Restaurant = "restaurant",
    Roofing_contractor = "roofing_contractor",
    Rv_park = "rv_park",
    School = "school",
    Shoe_store = "shoe_store",
    Shopping_mall = "shopping_mall",
    Spa = "spa",
    Stadium = "stadium",
    Storage = "storage",
    Store = "store",
    Subway_station = "subway_station",
    Synagogue = "synagogue",
    Tourist_attraction = "tourist_attraction",
    Taxi_stand = "taxi_stand",
    Train_station = "train_station",
    Travel_agency = "travel_agency",
    University = "university",
    Veterinary_care = "veterinary_care",
    Zoo = "zoo",
    Plus_code = "plus_code",
}

export class PlusCode implements IPlusCode {
    global_code?: string | null;
    compound_code?: string | null;

    constructor(data?: IPlusCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.global_code = _data["global_code"] !== undefined ? _data["global_code"] : <any>null;
            this.compound_code = _data["compound_code"] !== undefined ? _data["compound_code"] : <any>null;
        }
    }

    static fromJS(data: any): PlusCode {
        data = typeof data === 'object' ? data : {};
        let result = new PlusCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["global_code"] = this.global_code !== undefined ? this.global_code : <any>null;
        data["compound_code"] = this.compound_code !== undefined ? this.compound_code : <any>null;
        return data;
    }
}

export interface IPlusCode {
    global_code?: string | null;
    compound_code?: string | null;
}

/** Request check-in parameters */
export class RequestCheckInParameters implements IRequestCheckInParameters {
    /** MAC */
    mac?: string | null;
    /** Device serial - optional */
    deviceSerial?: string | null;
    /** Bar id */
    barId?: string | null;
    /** OpenerFLow */
    openerFlow?: string | null;

    constructor(data?: IRequestCheckInParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mac = _data["mac"] !== undefined ? _data["mac"] : <any>null;
            this.deviceSerial = _data["deviceSerial"] !== undefined ? _data["deviceSerial"] : <any>null;
            this.barId = _data["barId"] !== undefined ? _data["barId"] : <any>null;
            this.openerFlow = _data["openerFlow"] !== undefined ? _data["openerFlow"] : <any>null;
        }
    }

    static fromJS(data: any): RequestCheckInParameters {
        data = typeof data === 'object' ? data : {};
        let result = new RequestCheckInParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mac"] = this.mac !== undefined ? this.mac : <any>null;
        data["deviceSerial"] = this.deviceSerial !== undefined ? this.deviceSerial : <any>null;
        data["barId"] = this.barId !== undefined ? this.barId : <any>null;
        data["openerFlow"] = this.openerFlow !== undefined ? this.openerFlow : <any>null;
        return data;
    }
}

/** Request check-in parameters */
export interface IRequestCheckInParameters {
    /** MAC */
    mac?: string | null;
    /** Device serial - optional */
    deviceSerial?: string | null;
    /** Bar id */
    barId?: string | null;
    /** OpenerFLow */
    openerFlow?: string | null;
}

export class Result implements IResult {
    place_id?: string | null;
    geometry?: Geometry | null;
    formatted_address?: string | null;
    partial_match?: boolean | null;
    plus_code?: PlusCode | null;
    postcode_localities?: string[] | null;
    types?: PlaceLocationType[] | null;
    address_components?: AddressComponent[] | null;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.place_id = _data["place_id"] !== undefined ? _data["place_id"] : <any>null;
            this.geometry = _data["geometry"] ? Geometry.fromJS(_data["geometry"]) : <any>null;
            this.formatted_address = _data["formatted_address"] !== undefined ? _data["formatted_address"] : <any>null;
            this.partial_match = _data["partial_match"] !== undefined ? _data["partial_match"] : <any>null;
            this.plus_code = _data["plus_code"] ? PlusCode.fromJS(_data["plus_code"]) : <any>null;
            if (Array.isArray(_data["postcode_localities"])) {
                this.postcode_localities = [] as any;
                for (let item of _data["postcode_localities"])
                    this.postcode_localities!.push(item);
            }
            else {
                this.postcode_localities = <any>null;
            }
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            else {
                this.types = <any>null;
            }
            if (Array.isArray(_data["address_components"])) {
                this.address_components = [] as any;
                for (let item of _data["address_components"])
                    this.address_components!.push(AddressComponent.fromJS(item));
            }
            else {
                this.address_components = <any>null;
            }
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["place_id"] = this.place_id !== undefined ? this.place_id : <any>null;
        data["geometry"] = this.geometry ? this.geometry.toJSON() : <any>null;
        data["formatted_address"] = this.formatted_address !== undefined ? this.formatted_address : <any>null;
        data["partial_match"] = this.partial_match !== undefined ? this.partial_match : <any>null;
        data["plus_code"] = this.plus_code ? this.plus_code.toJSON() : <any>null;
        if (Array.isArray(this.postcode_localities)) {
            data["postcode_localities"] = [];
            for (let item of this.postcode_localities)
                data["postcode_localities"].push(item);
        }
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        if (Array.isArray(this.address_components)) {
            data["address_components"] = [];
            for (let item of this.address_components)
                data["address_components"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResult {
    place_id?: string | null;
    geometry?: Geometry | null;
    formatted_address?: string | null;
    partial_match?: boolean | null;
    plus_code?: PlusCode | null;
    postcode_localities?: string[] | null;
    types?: PlaceLocationType[] | null;
    address_components?: AddressComponent[] | null;
}

export class SimpleTag implements ISimpleTag {
    tag?: string | null;
    value?: string | null;

    constructor(data?: ISimpleTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): SimpleTag {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface ISimpleTag {
    tag?: string | null;
    value?: string | null;
}

export class Staff implements IStaff {
    id?: number | null;
    organizationId?: number | null;
    user?: UserInfo | null;
    barId?: number | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    timestamp?: string | null;

    constructor(data?: IStaff) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.user = _data["user"] ? UserInfo.fromJS(_data["user"]) : <any>null;
            this.barId = _data["barId"] !== undefined ? _data["barId"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.timestamp = _data["timestamp"] !== undefined ? _data["timestamp"] : <any>null;
        }
    }

    static fromJS(data: any): Staff {
        data = typeof data === 'object' ? data : {};
        let result = new Staff();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["barId"] = this.barId !== undefined ? this.barId : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : <any>null;
        return data;
    }
}

export interface IStaff {
    id?: number | null;
    organizationId?: number | null;
    user?: UserInfo | null;
    barId?: number | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    timestamp?: string | null;
}

export class StaffInvitation implements IStaffInvitation {
    id?: number | null;
    organizationId?: number | null;
    code?: string | null;
    validUntil?: Date | null;
    barId?: number | null;
    staffId?: number | null;
    status?: StaffInvitationStatus | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    timestamp?: string | null;

    constructor(data?: IStaffInvitation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.barId = _data["barId"] !== undefined ? _data["barId"] : <any>null;
            this.staffId = _data["staffId"] !== undefined ? _data["staffId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.timestamp = _data["timestamp"] !== undefined ? _data["timestamp"] : <any>null;
        }
    }

    static fromJS(data: any): StaffInvitation {
        data = typeof data === 'object' ? data : {};
        let result = new StaffInvitation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["barId"] = this.barId !== undefined ? this.barId : <any>null;
        data["staffId"] = this.staffId !== undefined ? this.staffId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : <any>null;
        return data;
    }
}

export interface IStaffInvitation {
    id?: number | null;
    organizationId?: number | null;
    code?: string | null;
    validUntil?: Date | null;
    barId?: number | null;
    staffId?: number | null;
    status?: StaffInvitationStatus | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    timestamp?: string | null;
}

export enum StaffInvitationStatus {
    Created = "Created",
    Accepted = "Accepted",
    Declined = "Declined",
    Expired = "Expired",
}

export class StaffQuery implements IStaffQuery {
    organizationId?: number | null;
    locationId?: number | null;
    skip?: number | null;
    maxItems?: number | null;
    nextToken?: string | null;

    constructor(data?: IStaffQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : <any>null;
            this.skip = _data["skip"] !== undefined ? _data["skip"] : <any>null;
            this.maxItems = _data["maxItems"] !== undefined ? _data["maxItems"] : <any>null;
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
        }
    }

    static fromJS(data: any): StaffQuery {
        data = typeof data === 'object' ? data : {};
        let result = new StaffQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["locationId"] = this.locationId !== undefined ? this.locationId : <any>null;
        data["skip"] = this.skip !== undefined ? this.skip : <any>null;
        data["maxItems"] = this.maxItems !== undefined ? this.maxItems : <any>null;
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        return data;
    }
}

export interface IStaffQuery {
    organizationId?: number | null;
    locationId?: number | null;
    skip?: number | null;
    maxItems?: number | null;
    nextToken?: string | null;
}

export class StaffQueryResponse implements IStaffQueryResponse {
    items?: Staff[] | null;
    total?: number | null;
    nextToken?: string | null;

    constructor(data?: IStaffQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Staff.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
        }
    }

    static fromJS(data: any): StaffQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StaffQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        return data;
    }
}

export interface IStaffQueryResponse {
    items?: Staff[] | null;
    total?: number | null;
    nextToken?: string | null;
}

export class TagQueryItem implements ITagQueryItem {
    tag?: string | null;
    value?: string | null;

    constructor(data?: ITagQueryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): TagQueryItem {
        data = typeof data === 'object' ? data : {};
        let result = new TagQueryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface ITagQueryItem {
    tag?: string | null;
    value?: string | null;
}

export class TextValueModel implements ITextValueModel {
    value?: any | null;
    text?: string | null;
    displayOrder?: number | null;

    constructor(data?: ITextValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.displayOrder = _data["displayOrder"] !== undefined ? _data["displayOrder"] : <any>null;
        }
    }

    static fromJS(data: any): TextValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new TextValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["displayOrder"] = this.displayOrder !== undefined ? this.displayOrder : <any>null;
        return data;
    }
}

export interface ITextValueModel {
    value?: any | null;
    text?: string | null;
    displayOrder?: number | null;
}

export class UpdateBarRequest implements IUpdateBarRequest {
    bar?: Bar | null;
    outletVendors?: OutletVendor[] | null;
    uploadKey?: string | null;

    constructor(data?: IUpdateBarRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bar = _data["bar"] ? Bar.fromJS(_data["bar"]) : <any>null;
            if (Array.isArray(_data["outletVendors"])) {
                this.outletVendors = [] as any;
                for (let item of _data["outletVendors"])
                    this.outletVendors!.push(OutletVendor.fromJS(item));
            }
            else {
                this.outletVendors = <any>null;
            }
            this.uploadKey = _data["uploadKey"] !== undefined ? _data["uploadKey"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateBarRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBarRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bar"] = this.bar ? this.bar.toJSON() : <any>null;
        if (Array.isArray(this.outletVendors)) {
            data["outletVendors"] = [];
            for (let item of this.outletVendors)
                data["outletVendors"].push(item.toJSON());
        }
        data["uploadKey"] = this.uploadKey !== undefined ? this.uploadKey : <any>null;
        return data;
    }
}

export interface IUpdateBarRequest {
    bar?: Bar | null;
    outletVendors?: OutletVendor[] | null;
    uploadKey?: string | null;
}

export class UpdateOrganizationRequest implements IUpdateOrganizationRequest {
    id?: number | null;
    name?: string | null;
    description?: string | null;
    externalId?: string | null;

    constructor(data?: IUpdateOrganizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateOrganizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        return data;
    }
}

export interface IUpdateOrganizationRequest {
    id?: number | null;
    name?: string | null;
    description?: string | null;
    externalId?: string | null;
}

export class UserInfo implements IUserInfo {
    id?: string | null;
    name?: string | null;
    email?: string | null;
    phoneNo?: string | null;
    avatarUrl?: string | null;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNo = _data["phoneNo"] !== undefined ? _data["phoneNo"] : <any>null;
            this.avatarUrl = _data["avatarUrl"] !== undefined ? _data["avatarUrl"] : <any>null;
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNo"] = this.phoneNo !== undefined ? this.phoneNo : <any>null;
        data["avatarUrl"] = this.avatarUrl !== undefined ? this.avatarUrl : <any>null;
        return data;
    }
}

export interface IUserInfo {
    id?: string | null;
    name?: string | null;
    email?: string | null;
    phoneNo?: string | null;
    avatarUrl?: string | null;
}

export class ViewPort implements IViewPort {
    southwest?: Location | null;
    northeast?: Location | null;

    constructor(data?: IViewPort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.southwest = _data["southwest"] ? Location.fromJS(_data["southwest"]) : <any>null;
            this.northeast = _data["northeast"] ? Location.fromJS(_data["northeast"]) : <any>null;
        }
    }

    static fromJS(data: any): ViewPort {
        data = typeof data === 'object' ? data : {};
        let result = new ViewPort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["southwest"] = this.southwest ? this.southwest.toJSON() : <any>null;
        data["northeast"] = this.northeast ? this.northeast.toJSON() : <any>null;
        return data;
    }
}

export interface IViewPort {
    southwest?: Location | null;
    northeast?: Location | null;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}